/* eslint-disable */
/* GENERATED FILE - DO NOT MODIFY */
/* run yarn import-data to regenerate */
import { GridProduct, SkinProduct, MechProduct, InterfaceProduct, ProductRule, ConstantProductsShape } from "../types/productTypes"

const GridProducts: readonly GridProduct[] = 
[
  {
    "itemNo": "PDL327CEP-VW",
    "description": "PDL Iconic USB Charging Station with Shelf, 3 Outlet, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Other",
    "gangNo": null,
    "socketNo": null,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "PDL394/15G",
    "description": "PDL Iconic Single Switch Power Point Grid, Horizontal Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "15A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "3015G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL394/15G"
  },
  {
    "itemNo": "PDL394/20G",
    "description": "PDL Iconic Single Power Point Grid, Horizontal Mount, 250V, 20A",
    "displayName": "",
    "comparisonName": "20A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "3015G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL394/20G"
  },
  {
    "itemNo": "PDL394G",
    "description": "PDL Iconic Single Switch Power Point Grid, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "10A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "PDL391G",
    "slotPositions": [],
    "baseItemNo": "3015G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL394G"
  },
  {
    "itemNo": "PDL394-VW",
    "description": "PDL Iconic Single Switch Power Point, Horizontal Mount, 250 V, 10A, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "PDL391G",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL394C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL394G"
  },
  {
    "itemNo": "PDL394/15-VW",
    "description": "PDL Iconic Single Switch Power Point, Horizontal Mount, 250 V, 15 A, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL394/15C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL394/15G"
  },
  {
    "itemNo": "PDL394/20-VW",
    "description": "PDL Iconic Single Switch Power Point, Horizontal Mount, 250V, 20A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL394/20C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL394/20G"
  },
  {
    "itemNo": "PDL395H4XXUAG",
    "description": "PDL Iconic Quad Switch Power Point Grid with 2 extra switches, Horizontal Mount, 250V, 10A, Less Mechanisms",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 4,
    "slotCount": 2,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 28,
        "y": 44.4
      },
      {
        "x": 72,
        "y": 44.4
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL395H4XXUAG"
  },
  {
    "itemNo": "PDL395H4XXUA-VW",
    "description": "PDL Iconic Quad Switch Power Point with 2 extra switches, Horizontal Mount, 250V, 10A, Less Mechanisms, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 4,
    "slotCount": 2,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 28,
        "y": 44.4
      },
      {
        "x": 72,
        "y": 44.4
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL395H4XXC-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL395H4XXUAG"
  },
  {
    "itemNo": "PDL395H4-VW",
    "description": "PDL Iconic Quad Switch Power Point, Horizontal Mount, 250V,10A, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 4,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL395H4C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "PDL391G",
    "description": "PDL Iconic Single Switch Power Point Grid, Vertical Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": "PDL394G",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL391G"
  },
  {
    "itemNo": "PDL391-VW",
    "description": "PDL Iconic Single Switch Power Point, Vertical Mount, 250V,10A, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": "PDL394G",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL391C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL391G"
  },
  {
    "itemNo": "PDL395/15G",
    "description": "PDL Iconic Double Power Point Grid, Horizontal Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "15A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "3025G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL395/15G"
  },
  {
    "itemNo": "PDL395/15-VW",
    "description": "PDL Iconic Double Power Point, Horizontal Mount, 15A, 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL395/15C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL395/15G"
  },
  {
    "itemNo": "PDL395CSGZ",
    "description": "Iconic Connected Socket, Zigbee Default Mode Twin Horizontal, 10 A, 240 V, Grid",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "PDL395G",
    "description": "PDL Iconic Double Power Point Grid, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "10A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "PDL392X-VW",
    "slotPositions": [],
    "baseItemNo": "3025G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL395G"
  },
  {
    "itemNo": "PDL395-VW",
    "description": "PDL Iconic Double Switch Power Point, Horizontal Mount, 250V, 10A, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "PDL392X-VW",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL395C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL395G"
  },
  {
    "itemNo": "PDL392XUAG",
    "description": "PDL Iconic Double Switch Power Point Grid with 1 extra switch, Vertical Mount, 250V,10A, less Mechanism",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Vertical",
    "otherOrientation": "PDL395XUAG",
    "slotPositions": [
      {
        "x": 39.3,
        "y": 49.1
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL392XUAG"
  },
  {
    "itemNo": "PDL350G",
    "description": "PDL Iconic Switch Blank Grid Plate, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 0,
    "socketNo": null,
    "slotCount": 0,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL350G"
  },
  {
    "itemNo": "PDL381G",
    "description": "PDL Iconic Switch Grid, 1 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL381G"
  },
  {
    "itemNo": "PDL382G",
    "description": "PDL Iconic Switch Grid, 2 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL382G"
  },
  {
    "itemNo": "PDL383G",
    "description": "PDL Iconic Switch Grid, 3 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": null,
    "slotCount": 3,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 32.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 50,
        "y": 67.6
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL383G"
  },
  {
    "itemNo": "PDL384G",
    "description": "PDL Iconic Switch Grid, 4 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": null,
    "slotCount": 4,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 38.7
      },
      {
        "x": 59,
        "y": 38.7
      },
      {
        "x": 41,
        "y": 62.3
      },
      {
        "x": 59,
        "y": 62.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL384G"
  },
  {
    "itemNo": "PDL385G",
    "description": "PDL Iconic Switch Grid, 5 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 5,
    "socketNo": null,
    "slotCount": 5,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 32
      },
      {
        "x": 59.4,
        "y": 32
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 41,
        "y": 68.3
      },
      {
        "x": 59.4,
        "y": 68.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL385G"
  },
  {
    "itemNo": "PDL386G",
    "description": "PDL Iconic Switch Grid, 6 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 6,
    "socketNo": null,
    "slotCount": 6,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 32
      },
      {
        "x": 59.4,
        "y": 32
      },
      {
        "x": 41,
        "y": 50
      },
      {
        "x": 59.4,
        "y": 50
      },
      {
        "x": 41,
        "y": 68.3
      },
      {
        "x": 59.4,
        "y": 68.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL386G"
  },
  {
    "itemNo": "PDL381GM10",
    "description": "PDL Iconic Gridplate and Mechanism 1 Gang, 250V, 10AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": 0,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": "PDL381M10",
    "pro": false,
    "standaloneGridItemNo": "PDL381G"
  },
  {
    "itemNo": "PDL382GM10",
    "description": "PDL  Iconic Gridplate and Mechanism 2 Gang, 250V, 10AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": 0,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": "PDL381M10",
    "pro": false,
    "standaloneGridItemNo": "PDL382G"
  },
  {
    "itemNo": "PDL383GM10",
    "description": "PDL Iconic Gridplate and Mechanism 3 Gang, 250V, 10AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": 0,
    "slotCount": 3,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 32.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 50,
        "y": 67.6
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": "PDL381M10",
    "pro": false,
    "standaloneGridItemNo": "PDL383G"
  },
  {
    "itemNo": "PDL384GM10",
    "description": "PDL Iconic Gridplate and Mechanism 4 Gang, 250V, 10AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": 0,
    "slotCount": 4,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 38.7
      },
      {
        "x": 59,
        "y": 38.7
      },
      {
        "x": 41,
        "y": 62.3
      },
      {
        "x": 59,
        "y": 62.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": "PDL381M10",
    "pro": false,
    "standaloneGridItemNo": "PDL384G"
  },
  {
    "itemNo": "PDL347VH-VW",
    "description": "PDL Iconic Cooking Appliance Isolator Switch and Skin, Horizontal/Vertical Mount, Single Pole, 250V, 45A, Vivid White",
    "displayName": "",
    "comparisonName": "Single Pole",
    "type": "Other",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "3041/45",
    "includedSkinItemNo": "PDL347VHC-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "PDL361G",
    "description": "PDL Iconic - Switch Grid, Vertical/Horizontal Mount, 1 Gang",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL361C-VW",
    "includedMechItemNo": "40ML",
    "pro": false,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "PDL362G",
    "description": "PDL Iconic - Switch Grid, Vertical/Horizontal Mount, 2 Gang",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL362C-VW",
    "includedMechItemNo": "40ML",
    "pro": false,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "PDLP361-XW",
    "description": "PDL Pro Architrave Switch, Vertical Mount, 1 Gang, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP361-XW",
    "includedMechItemNo": "PDL381M20",
    "pro": true,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "PDLP362-XW",
    "description": "PDL Pro Architrave Switch, Vertical Mount, 2 Gang, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP362-XW",
    "includedMechItemNo": "PDL381M20",
    "pro": true,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "PDLP361-BK",
    "description": "PDL Pro Architrave Switch, Vertical Mount, 1 Gang, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP361-BK",
    "includedMechItemNo": "PDL381M20",
    "pro": true,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "PDLP362-BK",
    "description": "PDL Pro Architrave Switch, Vertical Mount, 2 Gang, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP362-BK",
    "includedMechItemNo": "PDL381M20",
    "pro": true,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "PDL381-VW",
    "description": "PDL Iconic Flush Switch, Vertical Mount, 1 Gang, 250V, 10AX, 1-Way/2-Way, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL381C-VW",
    "includedMechItemNo": "PDL381M10",
    "pro": false,
    "standaloneGridItemNo": "PDL381G"
  },
  {
    "itemNo": "PDL382-VW",
    "description": "PDL Iconic Flush Switch, Vertical Mount, 2 Gang, 250V, 10AX, 1-Way/2-Way, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL382C-VW",
    "includedMechItemNo": "PDL381M10",
    "pro": false,
    "standaloneGridItemNo": "PDL382G"
  },
  {
    "itemNo": "PDL383-VW",
    "description": "PDL Iconic Flush Switch, Vertical Mount, 3 Gang, 250V, 10AX, 1-Way/2-Way, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": null,
    "slotCount": 3,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 32.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 50,
        "y": 67.6
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL383C-VW",
    "includedMechItemNo": "PDL381M10",
    "pro": false,
    "standaloneGridItemNo": "PDL383G"
  },
  {
    "itemNo": "PDL384-VW",
    "description": "PDL Iconic Flush Switch, Vertical Mount, 4 Gang, 250V, 10AX, 1-Way/2-Way, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": null,
    "slotCount": 4,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 38.7
      },
      {
        "x": 59,
        "y": 38.7
      },
      {
        "x": 41,
        "y": 62.3
      },
      {
        "x": 59,
        "y": 62.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL384C-VW",
    "includedMechItemNo": "PDL381M10",
    "pro": false,
    "standaloneGridItemNo": "PDL384G"
  },
  {
    "itemNo": "PDL394XUAG",
    "description": "PDL Iconic Single Power Point Grid, Horizontal Mount, 1ExBlank, 10A, 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 30.1,
        "y": 49.8
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL394XUAG"
  },
  {
    "itemNo": "PDL395XUAG",
    "description": "PDL Iconic Double Switch Power Point Grid with 1 extra switch, Horizontal Mount, 250V,10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": "PDL392XUAG",
    "slotPositions": [
      {
        "x": 50,
        "y": 42.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL395XUAG"
  },
  {
    "itemNo": "PDL395X-VW",
    "description": "PDL Iconic Double Switch Power Point, Horizontal Mount, 250 V, 10A, Extra Removable Switch",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": "PDL392X-VW",
    "slotPositions": [
      {
        "x": 50,
        "y": 42.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL395XC-VW",
    "includedMechItemNo": "PDL381M10",
    "pro": false,
    "standaloneGridItemNo": "PDL395XUAG"
  },
  {
    "itemNo": "PDL392X-VW",
    "description": "PDL Iconic Double Switch Power Point, Vertical Mount, 250 V, 10 A with Removable Extra Switch, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Vertical",
    "otherOrientation": "PDL395X-VW",
    "slotPositions": [
      {
        "x": 39.3,
        "y": 49.1
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL392XC-VW",
    "includedMechItemNo": "PDL381M10",
    "pro": false,
    "standaloneGridItemNo": "PDL392XUAG"
  },
  {
    "itemNo": "PDL392-VW",
    "description": "PDL Iconic Twin Switch Power Point, Vertical Mount, 250V,10A, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": "PDL395X-VW",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDL392C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "PDL392XUAG"
  },
  {
    "itemNo": "PDLP394G",
    "description": "PDL Pro Single Power Point Grid, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "10A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "P3015G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP394G"
  },
  {
    "itemNo": "PDLP394-XW",
    "description": "PDL Pro Single Power Point, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP394C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP394G"
  },
  {
    "itemNo": "PDLP394-15G",
    "description": "PDL Pro Single Power Point Grid, Horizontal Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "15A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "P3015G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP394-15G"
  },
  {
    "itemNo": "PDLP394-15-XW",
    "description": "PDL Pro Single Power Point, Horizontal Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP394-15C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP394-15G"
  },
  {
    "itemNo": "PDLP394-20-XW",
    "description": "PDL Pro Single Power Point, Horizontal Mount, 250V, 20A, White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "PDLP395H4XXUAG",
    "description": "PDL Pro Quad Power Point Grid with 2 extra switches, Horizontal Mount, 250V, 10A, Less Mechanisms",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 4,
    "slotCount": 2,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 28,
        "y": 44.4
      },
      {
        "x": 72,
        "y": 44.4
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP395H4XXUAG"
  },
  {
    "itemNo": "PDLP395H4XXUA-XW",
    "description": "PDL Pro Quad Power Point with 2 extra switches, Horizontal Mount, 250V, 10A, Less Mechanisms",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 4,
    "slotCount": 2,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 28,
        "y": 44.4
      },
      {
        "x": 72,
        "y": 44.4
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP395H4XXUAC-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP395H4XXUAG"
  },
  {
    "itemNo": "PDLP395H4G",
    "description": "PDL Pro Quad Power Point Grid, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": null,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP395H4G"
  },
  {
    "itemNo": "PDLP395H4-XW",
    "description": "PDL Pro Quad Power Point, Horizontal Mount, 250V,10A, White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": null,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP395H4C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP395H4G"
  },
  {
    "itemNo": "PDLP391G",
    "description": "PDL Pro Single Power Point Grid, Vertical Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "10A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "P3015VG",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP391G"
  },
  {
    "itemNo": "PDLP391-XW",
    "description": "PDL Pro Single Power Point, Vertical Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP391C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP391G"
  },
  {
    "itemNo": "PDLP391-15G",
    "description": "PDL Pro Single Power Point Grid, Vertical Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "15A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "P3015VG",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP391-15G"
  },
  {
    "itemNo": "PDLP391-15-XW",
    "description": "PDL Pro Single Power Point, Vertical Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP391-15C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP391-15G"
  },
  {
    "itemNo": "PDLP394XG",
    "description": "PDL Pro Single Power Point Grid, Horizontal Mount, 1Ex20A 10A 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 30.1,
        "y": 49.8
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP394XG"
  },
  {
    "itemNo": "PDLP394X-XW",
    "description": "PDL Pro Single Power Point, Horizontal Mount, 1Ex20A 10A 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 30.1,
        "y": 49.8
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP394XC-XW",
    "includedMechItemNo": "PDL381M20",
    "pro": true,
    "standaloneGridItemNo": "PDLP394XG"
  },
  {
    "itemNo": "PDLP395G",
    "description": "PDL Pro Twin Power Point Grid, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "10A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "PDLP392G",
    "slotPositions": [],
    "baseItemNo": "P3025G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP395G"
  },
  {
    "itemNo": "PDLP395-XW",
    "description": "PDL Pro Twin Power Point, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "PDLP392G",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP395C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP395G"
  },
  {
    "itemNo": "PDLP395-15G",
    "description": "PDL Pro Twin Power Point Grid, Horizontal Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "15A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "P3025G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP395-15G"
  },
  {
    "itemNo": "PDLP395-15-XW",
    "description": "PDL Pro Twin Power Point, Horizontal Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP395-15C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP395-15G"
  },
  {
    "itemNo": "PDLP395RG",
    "description": "PDL Pro Twin Power Point Grid, Horizontal Mount, Round Earth, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP395RG"
  },
  {
    "itemNo": "PDLP395R-XW",
    "description": "PDL Pro Twin Power Point, Horizontal Mount, Round Earth, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP395RC-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP395RG"
  },
  {
    "itemNo": "PDLP395PI-XW",
    "description": "PDL Pro Twin Power Point, Horizontal Mount, Power Indicator, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "PDLP395USBAC-XW",
    "description": "PDL Pro Twin Power Point, Horizontal Mount, 1Ex2USBCHRG, Type A+C, 10A, 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP395USBAC-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "PDLP392G",
    "description": "PDL Pro Twin Power Point Grid, Vertical Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": "PDLP395G",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP392G"
  },
  {
    "itemNo": "PDLP392XG",
    "description": "PDL Pro Twin Power Point Grid, Vertical Mount, 1Ex20A, 10A, 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 39.3,
        "y": 49.1
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": "PDL381M20",
    "pro": true,
    "standaloneGridItemNo": "PDLP392XG"
  },
  {
    "itemNo": "PDLP392X-XW",
    "description": "PDL Pro Twin Power Point, Vertical Mount, 1Ex20A, 10A, 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 39.3,
        "y": 49.1
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP392XC-XW",
    "includedMechItemNo": "PDL381M20",
    "pro": true,
    "standaloneGridItemNo": "PDLP392XG"
  },
  {
    "itemNo": "PDLP392-XW",
    "description": "PDL Pro Twin Power Point, Vertical Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP392-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP392G"
  },
  {
    "itemNo": "PDLP395XG",
    "description": "PDL Pro Twin Power Point Grid, Horizontal Mount, 1Ex20A 10A 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 49.6,
        "y": 41.9
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": "PDL381M20",
    "pro": true,
    "standaloneGridItemNo": "PDLP395XG"
  },
  {
    "itemNo": "PDLP381G",
    "description": "PDL Pro Switch Grid, 1 Gang, Horizontal/Vertical Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP381G"
  },
  {
    "itemNo": "PDLP382G",
    "description": "PDL Pro Switch Grid, 2 Gang, Horizontal/Vertical Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP382G"
  },
  {
    "itemNo": "PDLP383G",
    "description": "PDL Pro Switch Grid, 3 Gang, Horizontal/Vertical Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": null,
    "slotCount": 3,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 32.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 50,
        "y": 67.6
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP383G"
  },
  {
    "itemNo": "PDLP384G",
    "description": "PDL Pro Switch Grid, 4 Gang, Horizontal/Vertical Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": null,
    "slotCount": 4,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 38.7
      },
      {
        "x": 59,
        "y": 38.7
      },
      {
        "x": 41,
        "y": 62.3
      },
      {
        "x": 59,
        "y": 62.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP384G"
  },
  {
    "itemNo": "PDLP385G",
    "description": "PDL Pro Switch Grid, 5 Gang, Horizontal/Vertical Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 5,
    "socketNo": null,
    "slotCount": 5,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 32
      },
      {
        "x": 59.4,
        "y": 32
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 41,
        "y": 68.3
      },
      {
        "x": 59.4,
        "y": 68.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP385G"
  },
  {
    "itemNo": "PDLP386G",
    "description": "PDL Pro Switch Grid, 6 Gang, Horizontal/Vertical Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 6,
    "socketNo": null,
    "slotCount": 6,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 39,
        "y": 30
      },
      {
        "x": 59,
        "y": 30
      },
      {
        "x": 39,
        "y": 50
      },
      {
        "x": 59,
        "y": 50
      },
      {
        "x": 39,
        "y": 70
      },
      {
        "x": 59,
        "y": 70
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "PDLP386G"
  },
  {
    "itemNo": "PDLP395X-XW",
    "description": "PDL Pro Twin Power Point, Horizontal Mount, 1Ex20A 10A 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 49.6,
        "y": 41.9
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP395XC-XW",
    "includedMechItemNo": "PDL381M20",
    "pro": true,
    "standaloneGridItemNo": "PDLP395XG"
  },
  {
    "itemNo": "PDLP381-XW",
    "description": "PDL Pro Flush Switch, Vertical Mount, 1 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP381C-XW",
    "includedMechItemNo": "PDL381M20",
    "pro": true,
    "standaloneGridItemNo": "PDLP381G"
  },
  {
    "itemNo": "PDLP382-XW",
    "description": "PDL Pro Flush Switch, Vertical Mount, 2 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP382C-XW",
    "includedMechItemNo": "PDL381M20",
    "pro": true,
    "standaloneGridItemNo": "PDLP382G"
  },
  {
    "itemNo": "PDLP383-XW",
    "description": "PDL Pro Flush Switch, Vertical Mount, 3 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": null,
    "slotCount": 3,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 32.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 50,
        "y": 67.6
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP383C-XW",
    "includedMechItemNo": "PDL381M20",
    "pro": true,
    "standaloneGridItemNo": "PDLP383G"
  },
  {
    "itemNo": "PDLP384-XW",
    "description": "PDL Pro Flush Switch, Vertical Mount, 4 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": null,
    "slotCount": 4,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 38.7
      },
      {
        "x": 59,
        "y": 38.7
      },
      {
        "x": 41,
        "y": 62.3
      },
      {
        "x": 59,
        "y": 62.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "PDLP384C-XW",
    "includedMechItemNo": "PDL381M20",
    "pro": true,
    "standaloneGridItemNo": "PDLP384G"
  }
]

const SkinProducts: readonly SkinProduct[] = 
[
  {
    "itemNo": "PDL394/15C-AN",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, Anthracite",
    "displayName": "Single Power Point 15Amp",
    "image": "3015_15C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394/15G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL394/15C-CY",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, Cool Grey",
    "displayName": "Single Power Point 15Amp",
    "image": "3015_15C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394/15G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL394/15C-VW",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, Vivid White",
    "displayName": "Single Power Point 15Amp",
    "image": "3015_15C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394/15G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL394/20C-AN",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 250V, 20A, Clip-On, Anthracite",
    "displayName": "Single Power Point 20Amp",
    "image": "3015_20C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394/20G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL394/20C-CY",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 250V, 20A, Clip-On, Cool Grey",
    "displayName": "Single Power Point 20Amp",
    "image": "3015_20C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394/20G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL394/20C-VW",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 250V, 20A, Clip-On, Vivid White",
    "displayName": "Single Power Point 20Amp",
    "image": "3015_20C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394/20G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395H4C-AN",
    "description": "PDL Iconic Quad Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On,Anthracite",
    "displayName": "Quad Power Point",
    "image": "3015_4-AN.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395H4C-CY",
    "description": "PDL Iconic Quad Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Quad Power Point",
    "image": "3015_4-CY.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395H4C-VW",
    "description": "PDL Iconic Quad Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Vivid White",
    "displayName": "Quad Power Point",
    "image": "3015_4C-VW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/4C-XW",
    "description": "PDL Iconic Quad Switch Power Point, Horizontal Mount, 250V,10A, Extra White",
    "displayName": "Quad Power Point",
    "image": "3015_4C-XW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395H4C-XB",
    "description": "Skin Socket Sw Horiz Quad 10A 250V XB",
    "displayName": "Quad Power Point",
    "image": "3015-4C-XB.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395H4XXC-AN",
    "description": "PDL Iconic Quad Power Point Skin with 2 extra switches, Horizontal Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "3015_4XXC-AN.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4XXUAG",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395H4XXC-CY",
    "description": "PDL Iconic Quad Power Point Skin with 2 extra switches, Horizontal Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "3015_4XXC-CY.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4XXUAG",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395H4XXC-VW",
    "description": "PDL Iconic Quad Power Point Skin with 2 extra switches, Horizontal Mount, 250V, 10A, Clip-On, Vivid White",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "3015_4XXC-VW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4XXUAG",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/4XXC-XW",
    "description": "PDL Iconic Quad Power Point Skin with 2 extra switches, Horizontal Mount, 250V, 10A, Clip-On, Extra White",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "3015_4XXC-XW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4XXUAG",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395H4XXC-XB",
    "description": "Skin Socket SwHorizQuad 2ExSw 10A 250V XB",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "3015-4XXC-XB.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4XXUAG",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL394C-AN",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Single Power Point",
    "image": "3015C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDL391C-AN"
  },
  {
    "itemNo": "PDL394C-CY",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Single Power Point",
    "image": "3015C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDL391C-CY"
  },
  {
    "itemNo": "PDL394C-VW",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Vivid White",
    "displayName": "Single Power Point",
    "image": "3015C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDL391C-VW"
  },
  {
    "itemNo": "PDL394C-XB",
    "description": "Skin Socket Horiz Single 10A 250V XB",
    "displayName": "Single Power Point",
    "image": "3015C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394G",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDL391C-XB"
  },
  {
    "itemNo": "3015C-XW",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Extra White",
    "displayName": "Single Power Point",
    "image": "3015C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394G",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL391C-AN",
    "description": "PDL Iconic Single Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Vertical Single Power Point",
    "image": "3015V-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL391G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDL394C-AN"
  },
  {
    "itemNo": "PDL391C-CY",
    "description": "PDL Iconic Single Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Vertical Single Power Point",
    "image": "3015VC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL391G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDL394C-CY"
  },
  {
    "itemNo": "PDL391C-VW",
    "description": "PDL Iconic Single Power Point Skin, Vertical Mount, 250V, 10A, Clip-On,Vivid White",
    "displayName": "Vertical Single Power Point",
    "image": "3015VC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL391G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDL394C-VW"
  },
  {
    "itemNo": "PDL391C-XB",
    "description": "Skin Socket Sw Vert Single 10A 250V XB",
    "displayName": "Vertical Single Power Point",
    "image": "3015VC-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL391G",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDL394C-XB"
  },
  {
    "itemNo": "PDL394XC-AN",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V Clip-On, Anthracite",
    "displayName": "Single Power Point with Extra switch",
    "image": "3015XC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394XUAG",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL394XC-CY",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V Clip-On, Cool Grey",
    "displayName": "Single Power Point with Extra switch",
    "image": "3015XC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394XUAG",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL394XC-VW",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V Clip-On, Vivid White",
    "displayName": "Single Power Point with Extra switch",
    "image": "3015XC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394XUAG",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL394XC-XB",
    "description": "Skin Socket Sw Horiz Sgl 1ExSw XB",
    "displayName": "Single Power Point with Extra switch",
    "image": "3015XC-XB.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394XUAG",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015XC-XW",
    "description": "PDL Iconic Single Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V Clip-On, Extra White",
    "displayName": "Single Power Point with Extra Switch",
    "image": "3015XC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394XUAG",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395/15C-AN",
    "description": "PDL Iconic Double Power Point Skin, Horizontal Mount, 15A, 250V, Clip-On, Anthracite",
    "displayName": "Double Power Point 15Amp",
    "image": "3025_15C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395/15G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395/15C-CY",
    "description": "PDL Iconic Double Power Point Skin, Horizontal Mount, 15A, 250V, Clip-On, Cool Grey",
    "displayName": "Double Power Point 15Amp",
    "image": "3025_15C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395/15G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395/15C-VW",
    "description": "PDL Iconic Double Power Point Skin, Horizontal Mount, 15A, 250V, Clip-On, Vivid White",
    "displayName": "Double Power Point 15Amp",
    "image": "3025_15C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395/15G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395C-AN",
    "description": "PDL Iconic Double Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Double Power Point",
    "image": "3025C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDL392C-AN"
  },
  {
    "itemNo": "PDL395C-CY",
    "description": "PDL Iconic Double Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Double Power Point",
    "image": "3025C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDL392C-CY"
  },
  {
    "itemNo": "PDL395C-VW",
    "description": "PDL Iconic Double Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Vivid White",
    "displayName": "Double Power Point",
    "image": "3025C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDL392C-VW"
  },
  {
    "itemNo": "PDL395C-XB",
    "description": "Skin Socket Sw Horiz Twin 10A 250V XB",
    "displayName": "Double Power Point",
    "image": "3025C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395G",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDL392C-XB"
  },
  {
    "itemNo": "3025C-XW",
    "description": "PDL Iconic Double Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Extra White",
    "displayName": "Double Power Point",
    "image": "3025C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395G",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395CSC-AN",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic, VW",
    "displayName": "Wiser Connected Double Power Point",
    "image": "3025CSC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395CSGZ",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "PDL395CSC-CY",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic, CY",
    "displayName": "Wiser Connected Double Power Point",
    "image": "3025CSC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395CSGZ",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "PDL395CSC-VW",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic, VW",
    "displayName": "Wiser Connected Double Power Point",
    "image": "3025CSC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395CSGZ",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "PDL392C-AN",
    "description": "PDL Iconic Double Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Vertical  Double Power Point  ",
    "image": "3025VC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Socket",
    "disableSlots": true,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDL395C-AN"
  },
  {
    "itemNo": "PDL392C-CY",
    "description": "PDL Iconic Double Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Vertical  Double Power Point  ",
    "image": "3025VC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Socket",
    "disableSlots": true,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDL395C-CY"
  },
  {
    "itemNo": "PDL392C-VW",
    "description": "PDL Iconic Double Power Point Skin, Vertical Mount, 250V, 10A, Clip-On,Vivid White",
    "displayName": "Vertical  Double Power Point  ",
    "image": "3025VC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Socket",
    "disableSlots": true,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDL395C-VW"
  },
  {
    "itemNo": "PDL392C-XB",
    "description": "Skin Socket SwVert Twin 10A 250V XB",
    "displayName": "Vertical  Double Power Point  ",
    "image": "3025VC-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Socket",
    "disableSlots": true,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDL395C-XB"
  },
  {
    "itemNo": "PDL392XC-AN",
    "description": "PDL Iconic Double Power Point Skin with Extra Switch, Vertical Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Vertical Double Power Point with Extra Switch  ",
    "image": "3025VXC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392X-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDL395XC-AN"
  },
  {
    "itemNo": "PDL392XC-CY",
    "description": "PDL Iconic Double Power Point Skin with Extra Switch, Vertical Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Vertical Double Power Point with Extra Switch  ",
    "image": "3025VXC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392X-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDL395XC-CY"
  },
  {
    "itemNo": "PDL392XC-VW",
    "description": "PDL Iconic Double Power Point Skin with Extra Switch, Vertical Mount, 250V, 10A, Clip-On, Vivid White",
    "displayName": "Vertical Double Power Point with Extra Switch  ",
    "image": "3025VXC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392X-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDL395XC-VW"
  },
  {
    "itemNo": "PDL392XC-XB",
    "description": "Skin Socket SwVertTwin 1ExSw XB",
    "displayName": "Vertical Double Power Point with Extra Switch  ",
    "image": "3025VXC-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392X-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDL395XC-XB"
  },
  {
    "itemNo": "PDL395XC-AN",
    "description": "PDL Iconic Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "3025XC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395X-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDL392XC-AN"
  },
  {
    "itemNo": "PDL395XC-CY",
    "description": "PDL Iconic Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "3025XC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395X-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDL392XC-CY"
  },
  {
    "itemNo": "PDL395XC-VW",
    "description": "PDL Iconic Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Clip-On, Vivid White",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "3025XC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395X-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDL392XC-VW"
  },
  {
    "itemNo": "PDL395XC-XB",
    "description": "Skin Socket Sw Horiz Twin 1ExSW 10A 250V XB",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "3025XC-XB.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395X-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDL392XC-XB"
  },
  {
    "itemNo": "3025XC-XW",
    "description": "PDL Iconic Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Clip-On, Extra White",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "3025XC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395X-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE395H4C-AG",
    "description": "PDL Iconic Essence Quad Power Point Skin, 250V, 10A, Horizontal, Clip-On, Ash Grey",
    "displayName": "Quad Power Point",
    "image": "E3015_4C-AG.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE395H4C-AW",
    "description": "PDL Iconic Essence Quad Power Point Skin, Horizontal Mount, 250V, 10A, Arctic White",
    "displayName": "Quad Power Point",
    "image": "E3015_4C-AW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE395H4XXC-AG",
    "description": "PDL Iconic Essence Quad Power Point Skin with 2 extra switches, Horizontal Mount, , 250V, 10A, Clip-On, Ash Grey",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "E3015_4XXUAC-AG.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4XXUAG",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "PDLE380AR32-AG",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE395H4XXC-AW",
    "description": "PDL Iconic Essence Quad Power Point Skin with 2 extra switches, Horizontal Mount, 10A, 250V, Arctic White",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "E3015_4XXUAC-AW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4XXUAG",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "PDLE380AR32-AW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE394C-AG",
    "description": "PDL Iconic Essence Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Ash Grey",
    "displayName": "Single Power Point",
    "image": "E3015C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394G",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE394C-AW",
    "description": "PDL Iconic Essence Single Power Point Skin, Horizontal Mount, 250V, 10A, Arctic White",
    "displayName": "Single Power Point",
    "image": "E3015C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394G",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE394XC-AG",
    "description": "PDL Iconic Essence Single Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Clip-On, Ash Grey",
    "displayName": "Single Power Point with Extra Switch",
    "image": "E3015XC-AG.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394XUAG",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "PDLE380AR32-AG",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE394XC-AW",
    "description": "PDL Iconic Essence Single Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Arctic White",
    "displayName": "Single Power Point with Extra Switch",
    "image": "E3015XC-AW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394XUAG",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "PDLE380AR32-AW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE395C-AG",
    "description": "PDL Iconic Essence Double Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Ash Grey",
    "displayName": "Double Power Point",
    "image": "E3025C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395G",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE395C-AW",
    "description": "PDL Iconic Essence Double Power Point Skin, Horizontal Mount, 250V, 10A, Arctic White",
    "displayName": "Double Power Point",
    "image": "E3025C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395G",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE395CSC-AG",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic Essence, AG",
    "displayName": "Connected Double Power Point",
    "image": "E3025CSC-AG.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395CSGZ",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "PDLE395CSC-AW",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic Essence, AW",
    "displayName": "Connected Double Power Point",
    "image": "E3025CSC-AW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395CSGZ",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "PDLE395XC-AG",
    "description": "PDL Iconic Essence Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Clip-On, Ash Grey",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "E3025XC-AG.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395X-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "PDLE380AR32-AG",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE395XC-AW",
    "description": "PDL Iconic Essence Double Power Point Skin with 1 extra switch, HorizontalMount, 250V, 10A, Arctic White",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "E3025XC-AW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395X-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "PDLE380AR32-AW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS395H4C-CE",
    "description": "PDL Iconic Styl Quad Power Point Skin, Horizontal Mount, 250V 10A, Crowne",
    "displayName": "Quad Power Point",
    "image": "S3015_4C-CE.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS395H4C-SH",
    "description": "PDL Iconic Styl Quad Power Point Skin, Horizontal Mount, 250V, 10A, Silver Shadow",
    "displayName": "Quad Power Point",
    "image": "S3015_4C-SH.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS395H4C-SV",
    "description": "PDL Iconic Styl Quad Power Point Skin, Horizontal Mount, 250V, 10A, Silver",
    "displayName": "Quad Power Point",
    "image": "S3015_4C-SV.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS395H4XXC-CE",
    "description": "PDL Iconic Styl Quad Power Point Skin with 2 extra switches, Horizontal Mount,250V, 10A, Crowne",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "S3015_4XXUAC-CE.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4XXUAG",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "PDLS381AR-CE",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS395H4XXC-SH",
    "description": "PDL Iconic Styl Quad Power Point Skin with 2 extra switches, Horizontal Mount, 10A, 250V, Silver Shadow",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "S3015_4XXUAC-SH.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4XXUAG",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "PDLS380AR-SH",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS395H4XXC-SV",
    "description": "PDL Iconic Styl Quad Power Point Skin with 2 extra switches, Horizontal Mount, 10A, 250V, Silver",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "S3015_4XXUAC-SV.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDL395H4XXUAG",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "PDLS381AR-SV",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS394C-CE",
    "description": "PDL Iconic Styl Single Power Point Skin, Horizontal Mount, 250V, 10A, Crowne",
    "displayName": "Single Power Point",
    "image": "S3015C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394G",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS394C-SH",
    "description": "PDL Iconic Styl Single Power Point Skin, Horizontal Mount, 250V, 10A, Silver Shadow",
    "displayName": "Single Power Point",
    "image": "S3015C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394G",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS394C-SV",
    "description": "PDL Iconic Styl Single Power Point Skin, Horizontal Mount, 250V, 10A, Silver",
    "displayName": "Single Power Point",
    "image": "S3015C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394G",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS394XC-CE",
    "description": "PDL Iconic Styl Single Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Crowne",
    "displayName": "Single Power Point with Extra Switch",
    "image": "S3015XC-CE.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394XUAG",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "PDLS381AR-CE",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS394XC-SH",
    "description": "PDL Iconic Styl Single Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Silver Shadow",
    "displayName": "Single Power Point with Extra Switch",
    "image": "S3015XC-SH.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394XUAG",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "PDLS380AR-SH",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS394XC-SV",
    "description": "PDL Iconic Styl Single Power Point Skin, Horizontal Mount, 250V, 10A, Silver",
    "displayName": "Single Power Point with Extra Switch",
    "image": "S3015XC-SV.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL394XUAG",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "PDLS381AR-SV",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS395C-CE",
    "description": "PDL Iconic Styl Double Power Point Skin, Horizontal Mount, 250V, 10A, Crowne",
    "displayName": "Double Power Point",
    "image": "S3025C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395G",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS395C-SH",
    "description": "PDL Iconic Styl Double Power Point Skin, Horizontal Mount, 250V, 10A, Silver Shadow",
    "displayName": "Double Power Point",
    "image": "S3025C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395G",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS395C-SV",
    "description": "PDL Iconic Styl Double Power Point Skin, Horizontal Mount, 250V, 10A, Silver",
    "displayName": "Double Power Point",
    "image": "S3025C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395G",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS395CSC-CE",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic Styl, CE",
    "displayName": "Connected Double Power Point",
    "image": "S3025CSC-CE.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395CSGZ",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "PDLS395CSC-SH",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic Styl, SH",
    "displayName": "Connected Double Power Point",
    "image": "S3025CSC-SH.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395CSGZ",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "PDLS395CSC-SV",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic Styl, SV",
    "displayName": "Connected Double Power Point",
    "image": "S3025CSC-SV.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395CSGZ",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "PDLS395XC-CE",
    "description": "PDL Iconic Styl Double Power Point Skin with 1 extra switch, Horizontal Mount,250V, 10A, Crowne",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "S3025XC-CE.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395X-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "PDLS381AR-CE",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS395XC-SH",
    "description": "PDL Iconic Styl Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Silver Shadow",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "S3025XC-SH.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395X-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "PDLS380AR-SH",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS395XC-SV",
    "description": "PDL Iconic Styl Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Silver",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "S3025XC-SV.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395X-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "PDLS381AR-SV",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL361C-AN",
    "description": "PDL Iconic Switch Plate Skin, 1 Gang, Architrave, Vertical Mount, Clip-On, Anthracite",
    "displayName": "Architrave 1 Switch",
    "image": "3041AC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL361G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL361C-CY",
    "description": "PDL Iconic Switch Plate Skin, 1 Gang, Architrave, Vertical Mount, Clip-On, Cool Grey",
    "displayName": "Architrave 1 Switch",
    "image": "3041AC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL361G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL361C-VW",
    "description": "PDL Iconic Switch Plate Skin, 1 Gang, Architrave, Vertical Mount, Clip-On, Vivid White",
    "displayName": "Architrave 1 Switch",
    "image": "3041AC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL361G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL381C-AN",
    "description": "PDL Iconic Switch Plate Skin, 1 Gang, Horizontal/Vertical Mount, Clip-On, Anthracite",
    "displayName": "1 Switch ",
    "image": "3041C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL381-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL381C-CY",
    "description": "PDL Iconic Switch Plate Skin, 1 Gang, Horizontal/Vertical Mount, Clip-On, Cool Grey",
    "displayName": "1 Switch ",
    "image": "3041C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL381-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL381C-VW",
    "description": "PDL Iconic Switch Plate Skin, 1 Gang, Horizontal/Vertical Mount, Clip-On, Vivid White",
    "displayName": "1 Switch ",
    "image": "3041C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL381-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL381C-XB",
    "description": "Skin Switch V/H 1G rocker XB",
    "displayName": "1 Switch ",
    "image": "3041C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL381-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3041C-XW",
    "description": "PDL Iconic Switch Plate Skin, 1 Gang, Horizontal/Vertical Mount, Clip-On, Extra White",
    "displayName": "1 Switch ",
    "image": "3041C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL381-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL362C-AN",
    "description": "PDL Iconic Switch Plate Skin, 2 Gang, Architrave, Vertical Mount, Clip-On, Anthracite",
    "displayName": "2 Switches",
    "image": "3042AC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL362G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL362C-CY",
    "description": "PDL Iconic Switch Plate Skin, 2 Gang, Architrave, Vertical Mount, Clip-On, Cool Grey",
    "displayName": "2 Switches",
    "image": "3042AC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL362G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL362C-VW",
    "description": "PDL Iconic Switch Plate Skin, 2 Gang, Architrave, Vertical Mount, Clip-On, Vivid White",
    "displayName": "2 Switches",
    "image": "3042AC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL362G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL382C-AN",
    "description": "PDL Iconic Switch Plate Skin, 2 Gang, Horizontal/Vertical Mount, Clip-On, Anthracite",
    "displayName": "2 Switches",
    "image": "3042C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL382-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL382C-CY",
    "description": "PDL Iconic Switch Plate Skin, 2 Gang, Horizontal/Vertical Mount, Clip-On, Cool Grey",
    "displayName": "2 Switches",
    "image": "3042C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL382-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL382C-VW",
    "description": "PDL Iconic Switch Plate Skin, 2 Gang, Horizontal/Vertical Mount, Clip-On, Vivid White",
    "displayName": "2 Switches",
    "image": "3042C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL382-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL382C-XB",
    "description": "Skin Switch V/H 2G rocker XB",
    "displayName": "2 Switches",
    "image": "3042C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL382-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3042C-XW",
    "description": "PDL Iconic Switch Plate Skin, 2 Gang, Horizontal/Vertical Mount, Clip-On, Extra White",
    "displayName": "2 Switches",
    "image": "3042C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL382-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL383C-AN",
    "description": "PDL Iconic Switch Plate Skin, 3 Gang, Horizontal/Vertical Mount, Anthracite",
    "displayName": "3 Switches",
    "image": "3043C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL383-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL383C-CY",
    "description": "PDL Iconic Switch Plate Skin, 3 Gang, Horizontal/Vertical Mount, Cool Grey",
    "displayName": "3 Switches",
    "image": "3043C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL383-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL383C-VW",
    "description": "PDL Iconic Switch Plate Skin, 3 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "3 Switches",
    "image": "3043C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL383-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL383C-XB",
    "description": "Skin Switch V/H 3G rocker XB",
    "displayName": "3 Switches",
    "image": "3043C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL383-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3043C-XW",
    "description": "PDL Iconic Switch Plate Skin, 3 Gang, Horizontal/Vertical Mount, Clip-On, Extra White",
    "displayName": "3 Switches",
    "image": "3043C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL383-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL384C-AN",
    "description": "PDL Iconic Switch Plate Skin, 4 Gang, Horizontal/Vertical Mount, Anthracite",
    "displayName": "4 Switches",
    "image": "3044C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL384-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL384C-CY",
    "description": "PDL Iconic Switch Plate Skin, 4 Gang, Horizontal/Vertical Mount, Cool Grey",
    "displayName": "4 Switches",
    "image": "3044C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL384-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL384C-VW",
    "description": "PDL Iconic Switch Plate Skin, 4 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "4 Switches",
    "image": "3044C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL384-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL384C-XB",
    "description": "Skin Switch V/H 4G rocker XB",
    "displayName": "4 Switches",
    "image": "3044C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL384-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3044C-XW",
    "description": "PDL Iconic Switch Plate Skin, 4 Gang, Horizontal/Vertical Mount, Clip-On, Extra White",
    "displayName": "4 Switches",
    "image": "3044C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL384-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL385C-XB",
    "description": "Skin Switch V/H 5G rocker XB",
    "displayName": "5 Switches",
    "image": "3045C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL385G",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL386C-XB",
    "description": "Skin Switch V/H 6G rocker XB",
    "displayName": "6 Switches",
    "image": "3046C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL386G",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE381C-AG",
    "description": "PDL Iconic Essence Switch Plate Skin, 1 Gang, Vertical/Horizontal, Clip-On, Ash Grey",
    "displayName": "1 Switch ",
    "image": "E3041C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL381-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "PDLE380AR32-AG",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE381C-AW",
    "description": "PDL Iconic Essence Switch Plate Skin, Vertical/Horizontal, 1 Gang, Arctic White",
    "displayName": "1 Switch ",
    "image": "E3041C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL381-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "PDLE380AR32-AW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE382C-AG",
    "description": "PDL Iconic Essence Switch Plate Skin, 2 Gang, Vertical/Horizontal, Clip-On, Ash Grey",
    "displayName": "2 Switches",
    "image": "E3042C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL382-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "PDLE380AR32-AG",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE382C-AW",
    "description": "PDL Iconic Essence Switch Plate Skin, Vertical/Horizontal, 2 Gang, Arctic White",
    "displayName": "2 Switches",
    "image": "E3042C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL382-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "PDLE380AR32-AW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE383C-AG",
    "description": "PDL Iconic Essence Switch Plate Skin, 3 Gang, Vertical/Horizontal, Clip-On, Ash Grey",
    "displayName": "3 Switches",
    "image": "E3043C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL383-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "PDLE380AR32-AG",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE383C-AW",
    "description": "PDL Iconic Essence Switch Plate Skin, Vertical/Horizontal, 3 Gang, Arctic White",
    "displayName": "3 Switches",
    "image": "E3043C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL383-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "PDLE380AR32-AW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE384C-AG",
    "description": "PDL Iconic Essence Switch Plate Skin, 4 Gang, Vertical/Horizontal, Clip-On, Ash Grey",
    "displayName": "4 Switches",
    "image": "E3044C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL384-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "PDLE380AR32-AG",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE384C-AW",
    "description": "PDL Iconic Essence Switch Plate Skin, Vertical/Horizontal, 4 Gang, Arctic White",
    "displayName": "4 Switches",
    "image": "E3044C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL384-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "PDLE380AR32-AW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS381C-CE",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 1 Gang, Crowne",
    "displayName": "1 Switch ",
    "image": "S3041C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL381-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "PDLS381AR-CE",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS381C-SH",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 1 Gang, Silver Shadow",
    "displayName": "1 Switch ",
    "image": "S3041C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL381-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "PDLS380AR-SH",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS381C-SV",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 1 Gang, Silver",
    "displayName": "1 Switch ",
    "image": "S3041C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL381-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "PDLS381AR-SV",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS382C-CE",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 2 Gang, Crowne",
    "displayName": "2 Switches",
    "image": "S3042C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL382-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "PDLS381AR-CE",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS382C-SH",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 2 Gang, Silver Shadow",
    "displayName": "2 Switches",
    "image": "S3042C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL382-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "PDLS380AR-SH",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS382C-SV",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 2 Gang, Silver",
    "displayName": "2 Switches",
    "image": "S3042C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL382-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "PDLS381AR-SV",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS383C-CE",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 3 Gang, Crowne",
    "displayName": "3 Switches",
    "image": "S3043C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL383-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "PDLS381AR-CE",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS383C-SH",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 3 Gang, Silver Shadow",
    "displayName": "3 Switches",
    "image": "S3043C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL383-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "PDLS380AR-SH",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS383C-SV",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 3 Gang, Silver",
    "displayName": "3 Switches",
    "image": "S3043C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL383-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "PDLS381AR-SV",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS384C-CE",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 4 Gang, Crowne",
    "displayName": "4 Switches",
    "image": "S3044C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL384-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "PDLS381AR-CE",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS384C-SH",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 4 Gang, Silver Shadow",
    "displayName": "4 Switches",
    "image": "S3044C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL384-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "PDLS380AR-SH",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS384C-SV",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 4 Gang, Silver",
    "displayName": "4 Switches",
    "image": "S3044C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL384-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "PDLS381AR-SV",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL306-AN",
    "description": "PDL Iconic Night Walk Sensor Light, Motion Activated, Anthracite",
    "displayName": "Night Walk Sensor",
    "image": "3025NW-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL306-CY",
    "description": "PDL Iconic Night Walk Sensor Light, Motion Activated, Cool Grey",
    "displayName": "Night Walk Sensor",
    "image": "3025NW-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL306-VW",
    "description": "PDL Iconic Night Walk Sensor Light, Motion Activated, Vivid White",
    "displayName": "Night Walk Sensor",
    "image": "3025NW-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL395G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395USBAC-VW",
    "description": "PDL Iconic Switched Socket 1xEx2 USB C charger A+C",
    "displayName": "Power Point with USB A+C Charger",
    "image": "3025USBAC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL347VHC-VW",
    "description": "PDL Iconic Switch Plate Skin, 1 Gang, Cooker, Horizontal/Vertical Mount, 250V, 45A,Clip-On, Vivid White",
    "displayName": "Cooker Switch 45 Amp",
    "image": "3041_45C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL347VH-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL347VHC-AN",
    "description": "PDL Iconic Switch Plate Skin, 1 Gang, Cooker, Horizontal/Vertical Mount, 250V, 45A,Clip-On, Anthracite",
    "displayName": "Cooker Switch 45 Amp",
    "image": "3041_45C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL347VH-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL347VHC-CY",
    "description": "PDL Iconic Switch Plate Skin, 1 Gang, Cooker,Horizontal/Vertical Mount, 250V, 45A,Clip-On, Cool Grey",
    "displayName": "Cooker Switch 45 Amp",
    "image": "3041_45C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL347VH-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "3041/45C-XW",
    "description": "PDL Iconic Switch Plate Skin, 1 Gang, Cooker, Horizontal/Vertical Mount, 250V, 45A,Clip-On, Extra White",
    "displayName": "Cooker Switch 45 Amp",
    "image": "3041_45C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL347VH-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL347VHC-XB",
    "description": "Skin Switch V/H Cooker DP 45A XB",
    "displayName": "Cooker Switch 45 Amp",
    "image": "3041_45C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL347VH-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE347VHC-AG",
    "description": "PDL Iconic Essence Switch Plate Skin, 1 Gang, Cooker, Vertical/Horizontal Mount, 45A, Clip-On, Ash Grey",
    "displayName": "Cooker Switch 45 Amp",
    "image": "E3041_45C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL347VH-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE347VHC-AW",
    "description": "PDL Iconic Essence Switch Plate Skin, Vertical/Horizontal, COOKER, 45A, Arctic White",
    "displayName": "Cooker Switch 45 Amp",
    "image": "E3042C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL347VH-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS347C-CE",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, COOKER, 45A, Crowne",
    "displayName": "Cooker Switch 45 Amp",
    "image": "S3041_45C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL347VH-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS347C-SH",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, COOKER, 45A, Silver Shadow",
    "displayName": "Cooker Switch 45 Amp",
    "image": "S3041_45C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL347VH-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS347C-SV",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, COOKER, 45A, Silver",
    "displayName": "Cooker Switch 45 Amp",
    "image": "S3041_45C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL347VH-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL350C-AN",
    "description": "PDL Iconic Switch Plate Skin, Blank, Horizontal/Vertical Mount, Anthracite",
    "displayName": "Blank Plate ",
    "image": "3040C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL350G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL350C-CY",
    "description": "PDL Iconic Switch Plate Skin, Blank, Horizontal/Vertical Mount, Cool Grey",
    "displayName": "Blank Plate ",
    "image": "3040C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL350G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL350C-VW",
    "description": "PDL Iconic Switch Plate Skin, Blank, Horizontal/Vertical Mount, Vivid White",
    "displayName": "Blank Plate ",
    "image": "3040C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL350G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL385C-AN",
    "description": "PDL Iconic Switch Plate Skin, 5 Gang, Horizontal/Vertical Mount, Anthracite",
    "displayName": "5 Switches",
    "image": "3045C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL385G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL385C-CY",
    "description": "PDL Iconic Switch Plate Skin, 5 Gang, Horizontal/Vertical Mount, Cool Grey",
    "displayName": "5 Switches",
    "image": "3045C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL385G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL385C-VW",
    "description": "PDL Iconic Switch Plate Skin, 5 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "5 Switches",
    "image": "3045C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL385G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3045C-XW",
    "description": "PDL Iconic Switch Plate Skin, 5 Gang, Horizontal/Vertical Mount, Clip-On, Extra White",
    "displayName": "5 Switches",
    "image": "3045C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL385G",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL386C-AN",
    "description": "PDL Iconic Switch Plate Skin, 6 Gang, Horizontal/Vertical Mount, Anthracite",
    "displayName": "6 Switches",
    "image": "3046C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL386G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "PDL381AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL386C-CY",
    "description": "PDL Iconic Switch Plate Skin, 6 Gang, Horizontal/Vertical Mount, Cool Grey",
    "displayName": "6 Switches",
    "image": "3046C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL386G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "PDL381AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL386C-VW",
    "description": "PDL Iconic Switch Plate Skin, 6 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "6 Switches",
    "image": "3046C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL386G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "PDL381AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3046C-XW",
    "description": "PDL Iconic Switch Plate Skin, 6 Gang, Horizontal/Vertical Mount, Clip-On, Extra White",
    "displayName": "6 Switches",
    "image": "3046C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL386G",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE385C-AG",
    "description": "PDL Iconic Essence Switch Plate Skin, 5 Gang, Vertical/Horizontal, Clip-On, Ash Grey",
    "displayName": "5 Switches",
    "image": "E3045C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL385G",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "PDLE380AR32-AG",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE385C-AW",
    "description": "PDL Iconic Essence Switch Plate Skin, Vertical/Horizontal, 5 Gang, Arctic White",
    "displayName": "5 Switches",
    "image": "E3045C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL385G",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "PDLE380AR32-AW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE386C-AG",
    "description": "PDL Iconic Essence Switch Plate Skin, 6 Gang, Vertical/Horizontal, Clip-On, Ash Grey",
    "displayName": "6 Switches",
    "image": "E3046C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL386G",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "PDLE380AR32-AG",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE386C-AW",
    "description": "PDL Iconic Essence Switch Plate Skin, Vertical/Horizontal, 6 Gang, Arctic White",
    "displayName": "6 Switches",
    "image": "E3046C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL386G",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "PDLE380AR32-AW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS385C-CE",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 5 Gang, Crowne",
    "displayName": "5 Switches",
    "image": "S3045C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL385G",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "PDLS381AR-CE",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS385C-SH",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 5 Gang, Silver Shadow",
    "displayName": "5 Switches",
    "image": "S3045C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL385G",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "PDLS380AR-SH",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS385C-SV",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 5 Gang, Silver",
    "displayName": "5 Switches",
    "image": "S3045C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL385G",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "PDLS381AR-SV",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS386C-CE",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 6 Gang, Crowne",
    "displayName": "6 Switches",
    "image": "S3046C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL386G",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "PDLS381AR-CE",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS386C-SH",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 6 Gang, Silver Shadow",
    "displayName": "6 Switches",
    "image": "S3046C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL386G",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "PDLS380AR-SH",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS386C-SV",
    "description": "PDL Iconic Styl Switch Plate Skin, Vertical/Horizontal, 6 Gang, Silver",
    "displayName": "6 Switches",
    "image": "S3046C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL386G",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "PDLS381AR-SV",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL350C-XB",
    "description": "Skin Switch V/H Blank Plate XB",
    "displayName": "Blank Plate ",
    "image": "3040C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDL350G",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL155H4",
    "description": "Quad Socket Mounting Bracket horizontal",
    "displayName": "Horizontal Quad Socket Bracket Mount",
    "image": "3155H4.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL300APP/100",
    "description": "Paint Protector",
    "displayName": "Paint Protector",
    "image": "3000PP_100.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3157/4PRM",
    "description": "Quad Socket Plastic Wall Box (54mm depth)",
    "displayName": "Quad Socket Plastic Wall Box (54mm depth)",
    "image": "3157_4PRM.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395H4MB-VW",
    "description": "Quad Socket Mounting Block (38mm depth)",
    "displayName": "Quad Socket Mounting Block (38mm depth)",
    "image": "3004M-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL137MB-VW",
    "description": "Standard Mounting Block (34mm depth)",
    "displayName": "Standard Mounting Block (34mm depth)",
    "image": "449AB-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL300SMB-VW",
    "description": "Shallow Iconic Mounting Block (32mm depth)",
    "displayName": "Shallow Iconic Mounting Block (32mm depth)",
    "image": "3000SM-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL300DMB-VW",
    "description": "Deep Iconic Mounting Block (40mm depth)",
    "displayName": "Deep Iconic Mounting Block (40mm depth)",
    "image": "3000DM-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL327CEP-VW",
    "description": "PDL Iconic Cable Entry Plate, Horizontal Mount, Vivid White",
    "displayName": "Iconic Cable Entry Plate",
    "image": "3040CEP-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL381VWP-VW",
    "description": "PDL Iconic Switch, Vertical, 1 Gang, 1/2 Way, 10AX, 250V, IP44",
    "displayName": "1 Switch, IP44",
    "image": "3041V44-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL382VWP-VW",
    "description": "PDL Iconic Switch, Vertical, 2 Gang, 1/2 Way, 10AX, 250V, IP44",
    "displayName": "2 Switches, IP44",
    "image": "3042V44-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL383VWP-VW",
    "description": "PDL Iconic Switch, Vertical, 3 Gang, 1/2 Way, 10AX, 250V, IP44",
    "displayName": "3 Switches, IP44",
    "image": "3043V44-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL384VWP-VW",
    "description": "PDL Iconic Switch, Vertical, 4 Gang, 1/2 Way, 10AX, 250V, IP44",
    "displayName": "4 Switches, IP44",
    "image": "3044V44-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLO395-XW",
    "description": "Iconic Outdoor Twin Switched Socket IP54",
    "displayName": "Double Power Point",
    "image": "O3025-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorXW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLO395-BK",
    "description": "Iconic Outdoor Twin Switched Socket IP54",
    "displayName": "Double Power Point",
    "image": "O3025-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorBK",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLO394-XW",
    "description": "Iconic Outdoor Single Switched Socket IP54",
    "displayName": "Single Power Point",
    "image": "O3015-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorXW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLO394-BK",
    "description": "Iconic Outdoor Single Switched Socket IP54",
    "displayName": "Single Power Point",
    "image": "O3015-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorBK",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLO394CS-XW",
    "description": "Iconic Outdoor Single Switched Socket with Timer IP54",
    "displayName": "Single Power Point with Timer",
    "image": "O3015T-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorXW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLO394CS-BK",
    "description": "Iconic Outdoor Single Switched Socket with Timer IP54",
    "displayName": "Single Power Point with Timer",
    "image": "O3015T-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorBK",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLO381-XW",
    "description": "Iconic Outdoor Single Switch IP66",
    "displayName": "1 Switch",
    "image": "O3041HA-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorXW",
    "includedRockerItemNo": null,
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLO381-BK",
    "description": "Iconic Outdoor Single Switch IP66",
    "displayName": "1 Switch",
    "image": "O3041HA-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorBK",
    "includedRockerItemNo": null,
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP395H4C-BK",
    "description": "PDL Pro Quad Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Black",
    "displayName": "Quad Power Point",
    "image": "P3015_4C-BK.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395H4XXUAG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Socket",
    "disableSlots": true,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP394-15C-BK",
    "description": "PDL Pro Single Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, Black",
    "displayName": "Single Power Point 15Amp",
    "image": "P3015_15C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP394-15G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDLP391-15C-BK"
  },
  {
    "itemNo": "PDLP395H4XXUAC-BK",
    "description": "PDL Pro Quad Power Point Skin with 2 extra switches, Horizontal Mount, 250V, 10A, Clip-On, Black",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "P3015-4XXC-BK.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395H4XXUAG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP394C-BK",
    "description": "PDL Pro Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Black",
    "displayName": "Single Power Point",
    "image": "P3015C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP394G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDLP391C-BK"
  },
  {
    "itemNo": "PDLP391-15C-BK",
    "description": "PDL Pro Single Power Point Skin, Vertical Mount, 250V, 15A, Clip-On, Black",
    "displayName": "Vertical Single Power Point 15Amp",
    "image": "P3015V15C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP391-15G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDLP394-15C-BK"
  },
  {
    "itemNo": "PDLP391C-BK",
    "description": "PDL Pro Single Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Black",
    "displayName": "Vertical Single Power Point ",
    "image": "P3015VC-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP391G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDLP394C-BK"
  },
  {
    "itemNo": "PDLP394XC-BK",
    "description": "PDL Pro Single Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V, Clip-On, Black",
    "displayName": "Single Power Point with Extra Switch",
    "image": "P3015XC-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP394XG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP395-15C-BK",
    "description": "PDL Pro Twin Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, Black",
    "displayName": "Double Power Point 15Amp",
    "image": "P3025-15C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395-15G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP395C-BK",
    "description": "PDL Pro Twin Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Black",
    "displayName": "Double Power Point",
    "image": "P3025C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDLP392C-BK"
  },
  {
    "itemNo": "PDLP395RC-BK",
    "description": "PDL Pro Twin Power Point Skin, Horizontal Mount, Round Earth, 250V, 10A, Clip-On, Black",
    "displayName": "Double Power Point, Round Earth",
    "image": "P3025LC-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395RG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP392C-BK",
    "description": "PDL Pro Twin Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Black",
    "displayName": "Vertical Double Power Point ",
    "image": "P3025VC-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP392G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDLP395C-BK"
  },
  {
    "itemNo": "PDLP392-XW",
    "description": "PDL Pro Twin Power Point, Vertical Mount, 250V, 10A",
    "displayName": "Vertical Double Power Point ",
    "image": "P3025V-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP392-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDLP395C-XW"
  },
  {
    "itemNo": "PDLP392XC-BK",
    "description": "PDL Pro Twin Power Point Skin, Vertical Mount, 1ExBlank, 10A, 250V, Clip-On, Black",
    "displayName": "Vertical Double Power Point with Extra Switch  ",
    "image": "P3025VXC-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP392XG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDLP395XC-BK"
  },
  {
    "itemNo": "PDLP395XC-BK",
    "description": "PDL Pro Twin Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V, Clip-On, Black",
    "displayName": "Double Power Point with Extra Switch",
    "image": "P3025XC-BK.png",
    "imageScale": 0.98,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395XG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDLP392XC-BK"
  },
  {
    "itemNo": "PDLP381C-BK",
    "description": "PDL Pro Switch Plate Skin, 1 Gang, Horizontal/Vertical Mount, Clip-On, Black",
    "displayName": "1 Switch ",
    "image": "P3041C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP381G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP382C-BK",
    "description": "PDL Pro Switch Plate Skin, 2 Gang, Horizontal/Vertical Mount, Clip-On, Black",
    "displayName": "2 Switches",
    "image": "P3042C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP382G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP383C-BK",
    "description": "PDL Pro Switch Plate Skin, 3 Gang, Horizontal/Vertical Mount, Clip-On, Black",
    "displayName": "3 Switches",
    "image": "P3043C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP383G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP384C-BK",
    "description": "PDL Pro Switch Plate Skin, 4 Gang, Horizontal/Vertical Mount, Clip-On, Black",
    "displayName": "4 Switches",
    "image": "P3044C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP384G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP385C-BK",
    "description": "PDL Pro Switch Plate Skin, 5 Gang, Horizontal/Vertical Mount, Clip-On, Black",
    "displayName": "5 Switches",
    "image": "P3045C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP385G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP386C-BK",
    "description": "PDL Pro Switch Plate Skin, 6 Gang, Horizontal/Vertical Mount, Clip-On, Black",
    "displayName": "6 Switches",
    "image": "P3046C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP386G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP395C-DB",
    "description": "PDL Pro Twin Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Dark Blue",
    "displayName": "Double Power Point",
    "image": "P3025C-DB.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395G",
    "style": "Pro",
    "color": "ProDB",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDLP392C-DB"
  },
  {
    "itemNo": "PDLP395C-RD",
    "description": "PDL Pro Twin Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Red",
    "displayName": "Double Power Point",
    "image": "P3025C-RD.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395G",
    "style": "Pro",
    "color": "ProRD",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDLP392C-RD"
  },
  {
    "itemNo": "PDLP392C-DB",
    "description": "PDL Pro Twin Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Dark Blue",
    "displayName": "Vertical Double Power Point ",
    "image": "P3025VC-DB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP392G",
    "style": "Pro",
    "color": "ProDB",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDLP395C-DB"
  },
  {
    "itemNo": "PDLP392C-RD",
    "description": "PDL Pro Twin Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Red",
    "displayName": "Vertical Double Power Point ",
    "image": "P3025VC-RD.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP392G",
    "style": "Pro",
    "color": "ProRD",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDLP395C-RD"
  },
  {
    "itemNo": "PDLP395H4C-XW",
    "description": "PDL Pro Quad Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, White",
    "displayName": "Quad Power Point",
    "image": "P3015_4C-XW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395H4XXUAG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Socket",
    "disableSlots": true,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP394C-XW",
    "description": "PDL Pro Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, White",
    "displayName": "Single Power Point",
    "image": "P3015C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP394G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDLP391C-XW"
  },
  {
    "itemNo": "PDLP394-15C-XW",
    "description": "PDL Pro Single Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, White",
    "displayName": "Single Power Point 15Amp",
    "image": "P3015_15C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP394-15G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP395H4XXUAC-XW",
    "description": "PDL Pro Quad Power Point Skin with 2 extra switches, Horizontal Mount, 250V, 10A, Clip-On, White",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "P3015-4XXC-XW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395H4XXUAG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP391C-XW",
    "description": "PDL Pro Single Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, White",
    "displayName": "Vertical Single Power Point",
    "image": "P3015VC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP391G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDLP394C-XW"
  },
  {
    "itemNo": "PDLP391-15C-XW",
    "description": "PDL Pro Single Power Point Skin, Vertical Mount, 250V, 15A, Clip-On, White",
    "displayName": "Vertical Single Power Point 15Amp",
    "image": "P3015V15C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP391-15G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP394XC-XW",
    "description": "PDL Pro Single Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V, Clip-On, White",
    "displayName": "Single Power Point with Extra Switch",
    "image": "P3015XC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP394XG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP395C-XW",
    "description": "PDL Pro Twin Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, White",
    "displayName": "Double Power Point",
    "image": "P3025C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDLP392-XW"
  },
  {
    "itemNo": "PDLP395-15C-XW",
    "description": "PDL Pro Twin Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, White",
    "displayName": "Double Power Point 15Amp",
    "image": "P3025-15C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395-15G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP395RC-XW",
    "description": "PDL Pro Twin Power Point Skin, Horizontal Mount, Round Earth, 250V, 10A, Clip-On, White",
    "displayName": "Double Power Point, Round Earth",
    "image": "P3025LC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395RG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP392XC-XW",
    "description": "PDL Pro Twin Power Point Skin, Vertical Mount, 1ExBlank, 10A, 250V, Clip-On, White",
    "displayName": "Vertical Double Power Point with Extra Switch  ",
    "image": "P3025VXC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP392XG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "PDLP395XC-XW"
  },
  {
    "itemNo": "PDLP395XC-XW",
    "description": "PDL Pro Twin Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V, Clip-On, White",
    "displayName": "Double Power Point with Extra Switch",
    "image": "P3025XC-XW.png",
    "imageScale": 0.98,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395XG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "PDLP392XC-XW"
  },
  {
    "itemNo": "PDLP395USBAC-XW",
    "description": "PDL Pro Twin Power Point, Horizontal Mount, 1Ex2USBCHRG, Type A+C, 10A, 250V",
    "displayName": "Power Point with USB A+C Charger",
    "image": "P3025USBAC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "PDLP395USBAC-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP381C-XW",
    "description": "PDL Pro Switch Plate Skin, 1 Gang, Horizontal/Vertical Mount, Clip-On, White",
    "displayName": "1 Switch ",
    "image": "P3041C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP381-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP382C-XW",
    "description": "PDL Pro Switch Plate Skin, 2 Gang, Horizontal/Vertical Mount, Clip-On, White",
    "displayName": "2 Switches",
    "image": "P3042C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP382-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP383C-XW",
    "description": "PDL Pro Switch Plate Skin, 3 Gang, Horizontal/Vertical Mount, Clip-On, White",
    "displayName": "3 Switches",
    "image": "P3043C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP383-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP384C-XW",
    "description": "PDL Pro Switch Plate Skin, 4 Gang, Horizontal/Vertical Mount, Clip-On, White",
    "displayName": "4 Switches",
    "image": "P3044C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP384-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP385C-XW",
    "description": "PDL Pro Switch Plate Skin, 5 Gang, Horizontal/Vertical Mount, Clip-On, White",
    "displayName": "5 Switches",
    "image": "P3045C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP385G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP386C-XW",
    "description": "PDL Pro Switch Plate Skin, 6 Gang, Horizontal/Vertical Mount, Clip-On, White",
    "displayName": "6 Switches",
    "image": "P3046C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP386G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP223H-3A",
    "description": "PDL Protective box IK10 with lockable lid",
    "displayName": "Protective Box IK10 Lockable Lid",
    "image": "P223H-3A.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP300APP-50",
    "description": "PDL Pro Protective Paint Cover - 50 pack",
    "displayName": "Paint Protector",
    "image": "P3000PP-50.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP3TOOL",
    "description": "PDL Pro Tool for Skin Removal",
    "displayName": "Skin Removal Tool",
    "image": "P3000T.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP347VH-XW",
    "description": "PDL Pro Cooking Appliance Isolator Switch, Horizontal/Vertical Mount, Single Pole, 250V, 45A",
    "displayName": "Single Pole Cooking Appliance Isolator Switch",
    "image": "P3041-45-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP381VWP-XW",
    "description": "PDL Pro Switch, Vertical, 1 Gang, 1/2 Way, 20A/16AX, 250V, IP44",
    "displayName": "1 Switch, IP44",
    "image": "P3041V44-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP382VWP-XW",
    "description": "PDL Pro Switch, Vertical, 2 Gang, 1/2 Way, 20A/16AX, 250V, IP44",
    "displayName": "2 Switches, IP44",
    "image": "P3042V44-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP383VWP-XW",
    "description": "PDL Pro Switch, Vertical, 3 Gang, 1/2 Way, 20A/16AX, 250V, IP44",
    "displayName": "3 Switches, IP44",
    "image": "P3043V44-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP350VH-BK",
    "description": "PDL Pro Blank Switch Plate, Horizontal/Vertical Mount",
    "displayName": "Blank Plate ",
    "image": "P3040VX-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP350VH-XW",
    "description": "PDL Pro Blank Switch Plate, Horizontal/Vertical Mount",
    "displayName": "Blank Plate ",
    "image": "P3040VX-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP361-XW",
    "description": "PDL Pro Architrave Switch, Vertical Mount, 1 Gang, 250V, 20A/16AX",
    "displayName": "Architrave 1 Switch",
    "image": "P3041A-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP361-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP362-XW",
    "description": "PDL Pro Architrave Switch, Vertical Mount, 2 Gang, 250V, 20A/16AX",
    "displayName": "Architrave 2 Switch",
    "image": "P3042A-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP362-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "PDLP381AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP361-BK",
    "description": "PDL Pro Architrave Switch, Vertical Mount, 1 Gang, 250V, 20A/16AX",
    "displayName": "Architrave 1 Switch",
    "image": "P3041A-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP361-BK",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLP362-BK",
    "description": "PDL Pro Architrave Switch, Vertical Mount, 2 Gang, 250V, 20A/16AX",
    "displayName": "Architrave 2 Switch",
    "image": "P3042A-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDLP362-BK",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "PDLP381AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS392C-CE",
    "description": "PDL Iconic Styl Double Power Point Skin, Vertical Mount, 250V, 10A, Crowne",
    "displayName": "Double Power Point",
    "image": "PDLS392C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392XUAG",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "PDLS381AR-CE",
    "type": "Socket",
    "disableSlots": true,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS392C-SH",
    "description": "PDL Iconic Styl Double Power Point Skin, Vertical Mount, 250V, 10A, Silver Shadow",
    "displayName": "Double Power Point",
    "image": "PDLS392C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392XUAG",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "PDLS380AR-SH",
    "type": "Socket",
    "disableSlots": true,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS392C-SV",
    "description": "PDL Iconic Styl Double Power Point Skin, Vertical Mount, 250V, 10A, Silver",
    "displayName": "Double Power Point",
    "image": "PDLS392C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392XUAG",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "PDLS381AR-SV",
    "type": "Socket",
    "disableSlots": true,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE392C-AW",
    "description": "PDL Iconic Essence Double Power Point Skin, Vertical Mount, 250V, 10A, Ash White",
    "displayName": "Double Power Point",
    "image": "PDLE392C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392XUAG",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "PDLE380AR32-AW",
    "type": "Socket",
    "disableSlots": true,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE392C-AG",
    "description": "PDL Iconic Essence Double Power Point Skin, Vertical Mount, 250V, 10A, Ash Grey",
    "displayName": "Double Power Point",
    "image": "PDLE392C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392XUAG",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "PDLE380AR32-AG",
    "type": "Socket",
    "disableSlots": true,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS392XC-CE",
    "description": "PDL Iconic Styl Double Power Point Skin, Vertical Mount, X Switch 250V, 10A, Crowne",
    "displayName": "Double Power Point with Extra Switch",
    "image": "PDLS392XC-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392X-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "PDLS381AR-CE",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS392XC-SH",
    "description": "PDL Iconic Styl Double Power Point Skin, Vertical Mount, 250V, 10A, X Switch Silver Shadow",
    "displayName": "Double Power Point with Extra Switch",
    "image": "PDLS392XC-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392X-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "PDLS380AR-SH",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLS392XC-SV",
    "description": "PDL Iconic Styl Double Power Point Skin, Vertical Mount, 250V, 10A, x Switch Silver",
    "displayName": "Double Power Point with Extra Switch",
    "image": "PDLS392XC-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392X-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "PDLS381AR-SV",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE392XC-AW",
    "description": "PDL Iconic Essence Double Power Point Skin, Vertical Mount, 250V, 10A, X Switch Ash White",
    "displayName": "Double Power Point with Extra Switch",
    "image": "PDLE392XC-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392X-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "PDLE380AR32-AW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDLE392XC-AG",
    "description": "PDL Iconic Essence Double Power Point Skin, Vertical Mount, X Switch 250V, 10A, Ash Grey",
    "displayName": "Double Power Point with Extra Switch",
    "image": "PDLE392XC-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "PDL392X-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "PDLE380AR32-AG",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL395USBC-VW",
    "description": "Iconic Double Power Point Horizontal Mount, Twin socket, 10A, 240V, USB Fast charger, Type C, 25W",
    "displayName": "Double Power Point with USB Type C",
    "image": "3025USBC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "PDL501902",
    "description": "Wiser Zigbee to IP Network Smart Hub 100-240 V AC, IP20",
    "displayName": "Wiser Hub",
    "displaySubtitle": "Zigbee to IP Network",
    "image": "CLP501902.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Hubs"
  },
  {
    "itemNo": "PDL501902_001",
    "description": "Wiser Smart Docking Kit, Table Stand",
    "displayName": "Wiser Hub Table Stand",
    "displaySubtitle": "Docking Kit",
    "image": "CLP501902_0001.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Hubs"
  },
  {
    "itemNo": "PDL724419",
    "description": "Wiser, IP Camera, Wi-Fi, Outdoor, IP56",
    "displayName": "Wiser IP Camera",
    "displaySubtitle": "Wi-Fi, Outdoor, IP56",
    "image": "CLP724419.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Cameras"
  },
  {
    "itemNo": "PDL723419",
    "description": "Wiser, IP Camera, Wi-Fi, Pan and Tilt Adjustment, Indoor, IP20",
    "displayName": "Wiser IP Camera",
    "displaySubtitle": "Wi-Fi, Pan and Tilt Adjustment, Indoor, IP20",
    "image": "CLP723419.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Cameras"
  },
  {
    "itemNo": "PDL595011",
    "description": "Wiser Motion Smart Sensor3 V DC, IP20",
    "displayName": "Wiser Motion Sensor",
    "displaySubtitle": "3V DC, IP20",
    "image": "CLP595011.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Sensors"
  },
  {
    "itemNo": "PDL593011",
    "description": "Wiser Temperature/Humidity Smart Sensor 3 V DC, IP20",
    "displayName": "Wiser Temperature/Humidity Sensor",
    "displaySubtitle": "White",
    "image": "CLP593011.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Sensors"
  },
  {
    "itemNo": "PDL592011",
    "description": "Wiser Water Leakage Smart Sensor 3 V DC, IP20",
    "displayName": "Wiser Water Leakage Sensor",
    "displaySubtitle": "White",
    "image": "CLP592011.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Sensors"
  },
  {
    "itemNo": "PDL591011",
    "description": "Wiser Window/Door Smart Sensor 3 V DC, IP44",
    "displayName": "Wiser Window/Door Sensor",
    "displaySubtitle": "White",
    "image": "CLP591011.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Sensors"
  },
  {
    "itemNo": "PDL501401",
    "description": "Wiser Smart IR Converter 100-240 V AC, 50/60 Hz, IP20",
    "displayName": "Wiser IR Converter",
    "displaySubtitle": "100-240 V AC, 50/60 Hz, IP20",
    "image": "CLP501401.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "IR Converter"
  },
  {
    "itemNo": "PDL5010WDZ",
    "description": "Wiser Micro Module Smart Dimmer 200 W Max, 240 V",
    "displayName": "Wiser Micro Module Dimmer",
    "displaySubtitle": "200 W Max, 240 V, Grey",
    "image": "CLP5010WDZ.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Micro Modules"
  },
  {
    "itemNo": "PDL5011WSZ",
    "description": "Wiser Micro Module Smart Switch 10 AX, 240 V",
    "displayName": "Wiser Micro Module Switch",
    "displaySubtitle": "10 AX, 240 V, Grey",
    "image": "CLP5011WSZ.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Micro Modules"
  },
  {
    "itemNo": "PDL5015WBZ",
    "description": "Wiser Micro Module Smart Blind Controller 4 A, 220-240 V AC, 50Hz",
    "displayName": "Wiser Micro Module Blind Controller",
    "displaySubtitle": "Grey",
    "image": "CLP5015WBZ.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Micro Modules"
  }
]

const InterfaceProducts: readonly InterfaceProduct[] = 
[
  {
    "itemNo": "PDLE380AR32-AW",
    "description": "PDL Iconic Essence Rocker, Blank, Arctic White",
    "name": "Standard",
    "image": "E40AR-AW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40AR",
    "mechs": [
      "PDL381M10",
      "40ML",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": [
      "PDL381M10",
      "PDL378M10"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLE380AR32-AG",
    "description": "PDL Iconic Essence Rocker, Blank, Ash Grey",
    "name": "Standard",
    "image": "E40AR-AG.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40AR",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": [
      "PDL381M10",
      "PDL378M10"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381AR-AN",
    "description": "PDL Iconic Blank Rocker, Anthracite, 10 Pack",
    "name": "Standard",
    "image": "40AR-AN.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40AR",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": [
      "PDL381M10",
      "PDL378M10"
    ],
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381AR-CY",
    "description": "PDL Iconic Blank Rocker, Cool Grey, 10 Pack",
    "name": "Standard",
    "image": "40AR-CY.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40AR",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": [
      "PDL381M10",
      "PDL378M10"
    ],
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381AR-VW",
    "description": "PDL Iconic Blank Rocker, Vivid White, 10 Pack",
    "name": "Standard",
    "image": "40AR-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40AR",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": [
      "PDL381M10",
      "PDL378M10"
    ],
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40AR-XW",
    "description": "Dolly Rocker BLANK Pck 10",
    "name": "Standard",
    "image": "40AR-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "XW",
    "baseItemNo": "40AR",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": [
      "PDL381M10",
      "PDL378M10"
    ],
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "40AR-XB",
    "description": "Dolly Rocker BLANK Pck 10",
    "name": "Standard",
    "image": "40AR-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "XB",
    "baseItemNo": "40AR",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": [
      "PDL381M10",
      "PDL378M10"
    ],
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLS381AR-CE",
    "description": "PDL Iconic Styl Rocker, Blank, Crowne",
    "name": "Standard",
    "image": "S40AR-CE.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40AR",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": [
      "PDL381M10",
      "PDL378M10"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS381AR-SV",
    "description": "PDL Iconic Styl Rocker, Blank, Silver",
    "name": "Standard",
    "image": "S40AR-SV.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40AR",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": [
      "PDL381M10",
      "PDL378M10"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS380AR-SH",
    "description": "PDL Iconic Styl Rocker, Blank, Silver Shadow",
    "name": "Standard",
    "image": "S40AR-SH.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40AR",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": [
      "PDL381M10",
      "PDL378M10"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E380AR32-AW",
    "description": "PDL Iconic Essence Rocker, 32A, Arctic White",
    "name": "32Amp Standard",
    "image": "E40R32-AW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40R32",
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E380AR32-AG",
    "description": "PDL Iconic Essence Rocker, 32A, Ash Grey",
    "name": "32Amp Standard",
    "image": "E40R32-AG.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40R32",
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL380AR32-AN",
    "description": "PDL Iconic 32A Rocker, Anthracite, 10 Pack",
    "name": "32Amp Standard",
    "image": "40R32-AN.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40R32",
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL380AR32-CY",
    "description": "PDL Iconic 32A Rocker, Cool Grey, 10 Pack",
    "name": "32Amp Standard",
    "image": "",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40R32",
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL380AR32-VW",
    "description": "PDL Iconic 32A Rocker, Vivid White, 10 Pack",
    "name": "32Amp Standard",
    "image": "",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40R32",
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40R32-XB",
    "description": "Dolly Rocker 32A BLANK Pck 10",
    "name": "32Amp Standard",
    "image": "40R32-XB.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "XB",
    "baseItemNo": "40R33",
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS380AR32-CE",
    "description": "PDL Iconic Styl Rocker, 32A, Crowne",
    "name": "32Amp Standard",
    "image": "S40R32-CE.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40R32",
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS380AR32-SV",
    "description": "PDL Iconic Styl Rocker, 32A, Silver",
    "name": "32Amp Standard",
    "image": "S40R32-SV.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40R32",
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS380AR32-SH",
    "description": "PDL Iconic Styl Rocker, 32A, Silver Shadow",
    "name": "32Amp Standard",
    "image": "S40R32-SH.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40R32",
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381PAM-VW",
    "description": "Dolly Rocker AUTO MANUAL PK10 VW",
    "name": "Auto Manual",
    "image": "PDL381PAM-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": null,
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381PDY-VW",
    "description": "Dolly Rocker DRYER PK10 VW",
    "name": "Dryer",
    "image": "PDL381PDY-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": null,
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381AFAN-VW",
    "description": "PDL Iconic Fan Rocker, Vivid White, 10 Pack",
    "name": "Fan",
    "image": "40FR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40RF",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381AFRIDGE-VW",
    "description": "PDL Iconic Fridge Rocker, Vivid White, 10 Pack",
    "name": "Fridge",
    "image": "40FRR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40FRR",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381AHEAT-VW",
    "description": "PDL Iconic Heat Rocker, Vivid White, 10 Pack",
    "name": "Heat",
    "image": "40HR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40RH",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381AHOOD-VW",
    "description": "Dolly Rocker HOOD PK10 VW",
    "name": "Hood",
    "image": "PDL381AHOOD-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": null,
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381PHW-VW",
    "description": "Dolly Rocker HOT WATER PK10 VW",
    "name": "Hot Water",
    "image": "PDL381PHW-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": null,
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381ALIGHT-VW",
    "description": "PDL Iconic Light Rocker, Vivid White, 10 Pack",
    "name": "Light",
    "image": "40LR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40RL",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381AMICROWVE-VW",
    "description": "PDL Iconic Microwave Rocker, Vivid White, 10 Pack",
    "name": "Microwave",
    "image": "PDL381AMICROWVE-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40MR",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381POF-VW",
    "description": "Dolly Rocker ON OFF PK10 VW",
    "name": "On Off",
    "image": "PDL381POF-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": null,
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381AOUTSIDE-VW",
    "description": "Dolly Rocker OUTSIDE PK10 VW",
    "name": "Outside",
    "image": "PDL381AOUTSIDE-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": null,
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381POVEN-VW",
    "description": "Dolly Rocker 32A OVEN PK10 VW",
    "name": "Oven",
    "image": "PDL381POVEN-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": null,
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381AWASTE-VW",
    "description": "Dolly Rocker WASTE PK10 VW",
    "name": "Waste",
    "image": "PDL381AWASTE-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": null,
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL315MBBR-TN",
    "description": "PDL Iconic Banana Audio Connector, Red Band, Translucent",
    "name": "Connector Banana Audio RD+BK",
    "image": "40BC2-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": [
      "PDL315MBBR-TN (RD)",
      "PDL315MBBR-TN (BK)"
    ],
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL315MBBR-TN (RD)",
    "description": "PDL Iconic Banana Audio Connector, Red Band, Translucent (RD)",
    "name": "Connector Banana Audio RD",
    "image": "40BC2_TN-RD.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL315MBBR-TN (BK)",
    "description": "PDL Iconic Banana Audio Connector, Red Band, Translucent (BK)",
    "name": "Connector Banana Audio BK",
    "image": "40BC2_TN-BK.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS300KBC-CE",
    "description": "PDL Iconic Styl Dimmer Knob Kit, Crowne",
    "name": "Rotary Dimmer",
    "image": "S40EDIMKB-CE.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "S40EDIMKB",
    "mechs": [
      "PDL354RDMLED2-VW",
      "PDL354RDMUN-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS300KBC-SV",
    "description": "PDL Iconic Styl Dimmer Knob Kit, Silver",
    "name": "Rotary Dimmer",
    "image": "S40EDIMKB-SV.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "S40EDIMKB",
    "mechs": [
      "PDL354RDMLED2-VW",
      "PDL354RDMUN-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS300KBC-SH",
    "description": "PDL Iconic Styl Dimmer Knob Kit, Silver Shadow",
    "name": "Rotary Dimmer",
    "image": "S40EDIMKB-SH.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "S40EDIMKB",
    "mechs": [
      "PDL354RDMLED2-VW",
      "PDL354RDMUN-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL300USB2CAC-AG",
    "description": "PDL Iconic - Mechanism Cap Dual USB Type A+C",
    "name": "Dual USB Type-A + Type C",
    "image": "40E2USBACCAP-AG.png",
    "category": "USB",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40E2USBACCAP",
    "mechs": [
      "PDL342USB2AC-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL300USB2CAC-AN",
    "description": "PDL Iconic - Mechanism Cap Dual USB Type A+C",
    "name": "Dual USB Type-A + Type C",
    "image": "40E2USBACCAP-AN.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40E2USBACCAP",
    "mechs": [
      "PDL342USB2AC-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL300USB2CAC-CY",
    "description": "PDL Iconic - Mechanism Cap Dual USB Type A+C",
    "name": "Dual USB Type-A + Type C",
    "image": "40E2USBACCAP-CY.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40E2USBACCAP",
    "mechs": [
      "PDL342USB2AC-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL300USB2CAC-VW",
    "description": "PDL Iconic - Mechanism Cap Dual USB Type A+C",
    "name": "Dual USB Type-A + Type C",
    "image": "40E2USBACCAP-VW.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40E2USBACCAP",
    "mechs": [
      "PDL342USB2AC-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL300USB2CAC-WY",
    "description": "PDL Iconic - Mechanism Cap Dual USB Type A+C",
    "name": "Dual USB Type-A + Type C",
    "image": "40E2USBACCAP-WY.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "WY",
    "baseItemNo": "40E2USBACCAP",
    "mechs": [
      "PDL342USB2AC-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL300KBC-AN",
    "description": "PDL Iconic Rotary Dimmer Knob Parts Pack, Anthracite",
    "name": "Rotary Dimmer",
    "image": "40EDIMKB-AN.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40EDIMKB",
    "mechs": [
      "PDL354RDMLED2-VW",
      "PDL354RDMUN-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL300KBC-CY",
    "description": "PDL Iconic Rotary Dimmer Knob Parts Pack, Cool Grey",
    "name": "Rotary Dimmer",
    "image": "40EDIMKB-CY.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40EDIMKB",
    "mechs": [
      "PDL354RDMLED2-VW",
      "PDL354RDMUN-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL300KBC-VW",
    "description": "PDL Iconic Rotary Dimmer Knob Parts Pack, Vivid White",
    "name": "Rotary Dimmer",
    "image": "40EDIMKB-VW.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40EDIMKB",
    "mechs": [
      "PDL354RDMLED2-VW",
      "PDL354RDMUN-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381PHOB-VW",
    "description": "Dolly Rocker 32A HOB PK10 VW",
    "name": "32A HOB",
    "image": "PDL381PHOB-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": null,
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381PRANGE-VW",
    "description": "Dolly Rocker 32A RANGE PK10 VW",
    "name": "32A Range",
    "image": "PDL381PRANGE-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": null,
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL352MPIR-TN",
    "description": "PDL Iconic PIR Motion Sensor Mechanism, 750W, 3-Wire",
    "name": "PIR Sensor",
    "image": "41EPIRM-TN.png",
    "category": "Accessories",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLE300PBC-AG",
    "description": "PDL Iconic Essence Pushbutton Assembly, Blank, Ash Grey",
    "name": "Pushbutton Dimmer",
    "image": "E40APB-AG.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40APB",
    "mechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PBSSL-VW",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "displayedMechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "PDL356PBSSL-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL300PBC-AN",
    "description": "PDL Iconic Pushbutton Assembly, Blank, Anthracite, 5 Pack",
    "name": "Pushbutton Dimmer",
    "image": "40APB-AN.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40APB",
    "mechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PBSSL-VW",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "displayedMechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "PDL356PBSSL-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL300PBC-CY",
    "description": "PDL Iconic Pushbutton Assembly, Blank, Cool Grey, 5 Pack",
    "name": "Pushbutton Dimmer",
    "image": "40APB-CY.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40APB",
    "mechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PBSSL-VW",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "displayedMechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "PDL356PBSSL-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL300PBC-VW",
    "description": "PDL Iconic Pushbutton Assembly, Blank, Vivid White, 5 Pack",
    "name": "Pushbutton Dimmer",
    "image": "40APB-VW.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40APB",
    "mechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PBSSL-VW",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "displayedMechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "PDL356PBSSL-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40APB-XB",
    "description": "Mech cap Push Button BLANK XB Pck 5",
    "name": "Pushbutton Dimmer",
    "image": "40AR-BK.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "XB",
    "baseItemNo": "40APB",
    "mechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PBSSL-VW",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "displayedMechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "PDL356PBSSL-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS300PBC-CE",
    "description": "PDL Iconic Styl Pushbutton Assembly, Blank, Crowne,",
    "name": "Pushbutton Dimmer",
    "image": "S40AR-CE.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40APB",
    "mechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PBSSL-VW",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "displayedMechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "PDL356PBSSL-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS300PBC-SV",
    "description": "PDL Iconic Styl Pushbutton Assembly, Blank, Silver",
    "name": "Pushbutton Dimmer",
    "image": "S40AR-SV.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40APB",
    "mechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PBSSL-VW",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "displayedMechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "PDL356PBSSL-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS300PBC-SH",
    "description": "PDL Iconic Styl Pushbutton Assembly, Blank, Silver Shadow",
    "name": "Pushbutton Dimmer",
    "image": "S40AR-SH.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40APB",
    "mechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PBSSL-VW",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "displayedMechs": [
      "PDL354PBDMUN-VW",
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL356PB2MBT-VW",
      "PDL354PBDMBTW-VW",
      "PDL356PBSSL-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PB10MBTZ-VW",
      "PDL356PB2MBTZ-VW",
      "PDL354PBDMBTZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL340MRB-TN",
    "description": "PDL Iconic Audio Connector, RCA Socket Pair, Translucent",
    "name": "RCA Audio RD+BK",
    "image": "40SPK_2-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": [
      "PDL340MRB-TN (RD)",
      "PDL340MRB-TN (BK)"
    ],
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL340MRB-TN (RD)",
    "description": "PDL Iconic Audio Connector, RCA Socket Pair, Translucent (RD)",
    "name": "RCA Audio RD",
    "image": "40SPK_2-TN-RD.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL340MRB-TN (BK)",
    "description": "PDL Iconic Audio Connector, RCA Socket Pair, Translucent (BK)",
    "name": "RCA Audio BK",
    "image": "40SPK_2-TN-BK.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS387A4R-CE",
    "description": "PDL Iconic Styl Knob Kit Rotary, Off-1-2-3, Crowne",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "S40RSM3KB-CE.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS387A4R-SV",
    "description": "PDL Iconic Styl Kit Knob Rotary, Off-1-2-3, Silver",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "S40RSM3KB-SV.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLS387A4R-SH",
    "description": "PDL Iconic Styl Kit Knob Rotary, Off-1-2-3, Silver Shadow",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "S40RSM3KB-SH.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL387A4R",
    "description": "PDL Iconic Rotary Switch Knob Kit, 4-Position 0-1-2-3, 4 Colours",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "40RSM3KB.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": [
      "PDL387A4R (VW)",
      "PDL387A4R (WY)",
      "PDL387A4R (CY)",
      "PDL387A4R (AN)"
    ],
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL387A4R (VW)",
    "description": "PDL Pro Rotary Switch Knob Kit, 4-Position 0-1-2-3, Black (VW)",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "40RSM3KB-VW.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL387A4R (WY)",
    "description": "PDL Pro Rotary Switch Knob Kit, 4-Position 0-1-2-3, Black (WY)",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "40RSM3KB-WY.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "WY",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL387A4R (CY)",
    "description": "PDL Pro Rotary Switch Knob Kit, 4-Position 0-1-2-3, Black (CY)",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "40RSM3KB-CY.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL387A4R (AN)",
    "description": "PDL Pro Rotary Switch Knob Kit, 4-Position 0-1-2-3, Black (AN)",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "40RSM3KB-AN.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL381ASENSOR-VW",
    "description": "PDL Iconic Sensor Rocker, Vivid White, 10 Pack",
    "name": "Sensor",
    "image": "40SR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40SR",
    "mechs": [
      "PDL381M10",
      "PDL381M20",
      "PDL380M20DP",
      "PDL378M10"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL315HDMI-TN",
    "description": "PDL Iconic HDMI Adaptor, Straight, Translucent",
    "name": "Socket HDMI Straight",
    "image": "40HDMIS-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL315MF-TN",
    "description": "PDL Iconic TV Antenna Socket, F-Type, Translucent",
    "name": "Socket TV F Type - F Type 3GHz",
    "image": "40PFM-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL328MF-TN",
    "description": "PDL Iconic TV Antenna Socket, F-Type Rear, Translucent",
    "name": "Socket TV PAL - F Type",
    "image": "40FFPMS-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL387A3T-AG",
    "description": "PDL Iconic Rocker, 3 Position, Ash Grey",
    "name": "Toggle 3-Position",
    "image": "49T-AG.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "49T",
    "mechs": [
      "PDL387M3T-VW",
      "PDLP387M3TM-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL387A3T-AN",
    "description": "PDL Iconic Rocker Toggle, 3-Position, Anthracite, Blank, 10 Pack",
    "name": "Toggle 3-Position",
    "image": "49T-AN.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "49T",
    "mechs": [
      "PDL387M3T-VW",
      "PDLP387M3TM-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL387A3T-CY",
    "description": "PDL Iconic Rocker Toggle, 3-Position, Cool Grey, Blank, 10 Pack",
    "name": "Toggle 3-Position",
    "image": "49T-CY.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "49T",
    "mechs": [
      "PDL387M3T-VW",
      "PDLP387M3TM-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL387A3T-VW",
    "description": "PDL Iconic Rocker Toggle, 3-Position, Vivid White, Blank, 10 Pack",
    "name": "Toggle 3-Position",
    "image": "49T-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "49T",
    "mechs": [
      "PDL387M3T-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "49T-XB",
    "description": "Dolly Toggle 3-pos BLANK Pck 10",
    "name": "Toggle 3-Position",
    "image": "P49TAOM-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "XB",
    "baseItemNo": "49T",
    "mechs": [
      "PDL387M3T-VW",
      "PDLP387M3TM-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL387A3T-WY",
    "description": "PDL Iconic Rocker Toggle, 3-Position, Warm Grey, Blank, 10 Pack",
    "name": "Toggle 3-Position",
    "image": "49T-WY.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "WY",
    "baseItemNo": "49T",
    "mechs": [
      "PDL387M3T-VW",
      "PDLP387M3TM-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL387ALBLKIT-VW",
    "description": "PDL Iconic Rocker Toggle, 3-Position, Marked SON -AOM-UOD, Vivid White, 3 Pack",
    "name": "Toggle SON-AOM-UOD",
    "image": "49MLBL-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "49MLBL",
    "mechs": [
      "PDL387M3T-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL351MPCU-TN",
    "description": "PDL Iconic Permanent Connection Unit (PCU)",
    "name": "Permanent Connection Unit (PCU)",
    "image": "48HD-TN.png",
    "category": "Accessories",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL300USB2CAC-BK",
    "description": "PDL Iconic USB Mechanism Cap, Dual USB Charger Type A+C, Black",
    "name": "Dual USB Type-A + Type C",
    "image": "40E2USBACCAP-BK.png",
    "category": "USB",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": null,
    "mechs": [
      "PDL342USB2AC-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDL319MKC-TN",
    "description": "Adaptor RJ Tyco KrOne Siemon, 10Pk.",
    "name": "Adaptor RJ Tyco KrOne Siemon",
    "image": "PDL319MKC-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "VDIB17386UTN",
    "description": "RJ45 JACK CAT6 UTP 40M TRANSLUCENT Iconic.",
    "name": "RJ45 JACK CAT6 UTP 40M TRANSLUCENT",
    "image": "VDIB17386U-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDL310ML-GN",
    "description": "PDL Iconic LED Mechanism, Green 250V",
    "name": "LED Mechanism, Green 250V",
    "image": "40N-GR.png",
    "category": "LED",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDL310ML-RD",
    "description": "PDL Iconic LED Mechanism, Red 250V",
    "name": "LED Mechanism, Red 250V",
    "image": "40N-RD.png",
    "category": "LED",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDL310ML24-GN",
    "description": "PDL Iconic LED Mechanism, Green 24V",
    "name": "LED Mechanism, Green 24V",
    "image": "40N24-GR.png",
    "category": "LED",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDL310ML24-RD",
    "description": "PDL Iconic LED Mechanism, Red 24V",
    "name": "LED Mechanism, Red 24V",
    "image": "40N24-RD.png",
    "category": "LED",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDL310MLPA-AM",
    "description": "PDL Iconic LED Mechanism, Marked Power Available, Amber 250V",
    "name": "Marked Power Available, Amber 250V",
    "image": "40NPA-AM.png",
    "category": "LED",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP381AR-BK",
    "description": "PDL Pro BLANK Rocker, Black",
    "name": "Standard",
    "image": "40AR-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40AR",
    "mechs": [
      "PDL381M20",
      "PDL381M10",
      "PDLP380M20DP",
      "PDL378M10L"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP381AR-XW",
    "description": "PDL Pro BLANK Rocker, White",
    "name": "Standard",
    "image": "P40AR-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40AR",
    "mechs": [
      "PDL381M20",
      "PDL381M10",
      "PDLP380M20DP",
      "PDL378M10L"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP300PBC-BK",
    "description": "PDL Pro Push button, Black",
    "name": "Push button ",
    "image": "P40APB-BK.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40APB",
    "mechs": [
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL354PBDMBTW-VW",
      "PDL354PBDMUN-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PBSSL-VW"
    ],
    "displayedMechs": [
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL354PBDMBTW-VW",
      "PDL356PBSSL-VW",
      "5041NMML",
      "5041NMS"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP300PBC-XW",
    "description": "PDL Pro Push button, White",
    "name": "Push button ",
    "image": "P40APB-XW.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40APB",
    "mechs": [
      "PDL354PBDMUN-VW",
      "PDL356PB10MBTW-VW",
      "PDL354PBDMBTW-VW",
      "PDL356PBSS-VW",
      "5041NMML",
      "5041NMS",
      "PDL356PBSSL-VW"
    ],
    "displayedMechs": [
      "PDL356PBSS-VW",
      "PDL356PB10MBTW-VW",
      "PDL354PBDMBTW-VW",
      "PDL356PBSSL-VW",
      "5041NMML",
      "5041NMS"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP381AFAN-XW",
    "description": "PDL Pro FAN Rocker, White",
    "name": "Fan",
    "image": "40FR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40RF",
    "mechs": [
      "PDL381M20",
      "PDL381M10",
      "PDLP380M20DP",
      "PDL378M10L"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP381AFRIDGE-XW",
    "description": "PDL Pro FRIDGE Rocker, White",
    "name": "Fridge",
    "image": "P40FRR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40FRR",
    "mechs": [
      "PDL381M20",
      "PDL381M10",
      "PDLP380M20DP",
      "PDL378M10L"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP381AHEAT-XW",
    "description": "PDL Pro HEAT Rocker, White",
    "name": "Heat",
    "image": "40HR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40RH",
    "mechs": [
      "PDL381M20",
      "PDL381M10",
      "PDLP380M20DP",
      "PDL378M10L"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP381ALR-BK",
    "description": "PDL Pro Locking BLANK Rocker, Black",
    "name": "Standard Locking",
    "image": "P40LOCKR-BK.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40LOCKR",
    "mechs": [
      "PDL381M20",
      "PDL381M10",
      "PDLP380M20DP",
      "PDL378M10L"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP381ALR-XW",
    "description": "PDL Pro Locking BLANK Rocker, White",
    "name": "Standard Locking",
    "image": "P40LOCKR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40LOCKR",
    "mechs": [
      "PDL381M20",
      "PDL381M10",
      "PDLP380M20DP",
      "PDL378M10L"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP381ALIGHT-XW",
    "description": "PDL Pro LIGHT Rocker, White",
    "name": "Light",
    "image": "40LR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40LR",
    "mechs": [
      "PDL381M20",
      "PDL381M10",
      "PDLP380M20DP",
      "PDL378M10L"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP380AR32-BK",
    "description": "PDL Pro 32A Rocker, Black",
    "name": "32Amp Standard",
    "image": "P40R32-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40R32",
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP380AR32-XW",
    "description": "PDL Pro 32A Rocker, White",
    "name": "32Amp Standard",
    "image": "P40R32-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40R32",
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP381ASENSOR-XW",
    "description": "PDL Pro SENSOR Rocker, White",
    "name": "Sensor",
    "image": "40SR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40SR",
    "mechs": [
      "PDL381M20",
      "PDL381M10",
      "PDLP380M20DP",
      "PDL378M10L"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP40CSFM-XW",
    "description": "PDL Pro Fan Speed Controller, 4-Position, Rotary Switch, Off-1-2-3, Capacitor 75VA",
    "name": "Fan Speed Controller",
    "image": "P40CSFM-XW.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "P40CSFM",
    "mechs": [
      "PDLP40CSFM-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLP300B-TN",
    "description": "PDL Pro Blank Mechanism Adaptor, PK5, Translucent",
    "name": "Standard Adaptor",
    "image": "P40-TN.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP300B-XW",
    "description": "PDL Pro Blank Mechanism Adaptor, PK5, White",
    "name": "Standard Adaptor",
    "image": "P40B-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP300KBC-BK",
    "description": "PDL Pro Rotary Dimmer Knob Parts Pack, Black",
    "name": "Rotary Dimmer",
    "image": "P40EDIMKB-BK.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40EDIMKB",
    "mechs": [
      "PDL354RDMLED2-VW",
      "PDL354RDMUN-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP300KBC-XW",
    "description": "PDL Pro Rotary Dimmer Knob Parts Pack, White",
    "name": "Rotary Dimmer",
    "image": "P40EDIMKB-XW.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40EDIMKB",
    "mechs": [
      "PDL354RDMLED2-VW",
      "PDL354RDMUN-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP300ALEDB-BK",
    "description": "PDL Pro LED Module,250V Bright White with Black Rocker",
    "name": "LED Module 250V ",
    "image": "P40MLEDBW-BK.png",
    "category": "LED",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40MLEDBW",
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLP300ALEDB-XW",
    "description": "PDL Pro LED Module,250V Bright White with White Rocker",
    "name": "LED Module 250V ",
    "image": "P40MLEDBW-XW.png",
    "category": "LED",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40MLEDBW",
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLP387M4R2-XW",
    "description": "PDL Pro Switch Mechanism, 4-Position, 250V, 10A, White",
    "name": "Rotary Knob OFF-1-OFF-2",
    "image": "40RSM2KB-VW.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "P40RSM2",
    "mechs": [
      "PDLP387M4R2-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLP387A4R2-BK",
    "description": "PDL Pro Rotary Switch Knob Kit, 4-Position 0-1-0-2, Black",
    "name": "Rotary Knob OFF-1-OFF-2",
    "image": "P40RSM2KB-BK.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40RSM2KB",
    "mechs": [
      "PDLP387M4R2-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLP387M4R3-XW",
    "description": "PDL Pro Switch Mechanism, 4-Position, 250V, 10A, White",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "P40RSM3-XW.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "P40RSM3",
    "mechs": [
      "PDLP387M4R3-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "PDLP387A4R3-BK",
    "description": "PDL Pro Rotary Switch Knob Kit, 4-Position 0-1-2-3, Black",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "P40RSM3KB-BK.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40RSM3KB",
    "mechs": [
      "PDLP387M4R3-XW",
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP387A3T-BK",
    "description": "PDL Pro Rocker Toggle 3-pos BLANK",
    "name": "Toggle 3-Position",
    "image": "P49T-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "49T",
    "mechs": [
      "PDLP387M3T-XW",
      "PDLP387M3TM-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP387M3T-XW",
    "description": "PDL Pro Rocker Toggle 3-pos BLANK",
    "name": "Toggle 3-Position",
    "image": "P49T-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "49T",
    "mechs": [
      "PDLP387M3T-XW",
      "PDLP387M3TM-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP387AAOM-XW",
    "description": "PDL Pro Rocker Toggle 3-pos AUTO-OFF-MANUAL",
    "name": "Toggle SON-AOM-UOD",
    "image": "P49TAOM-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "49TAOM",
    "mechs": [
      "PDLP387M3T-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP387ASON-XW",
    "description": "PDL Pro Rocker Toggle 3-pos SENSOR-ON-OFF",
    "name": "Toggle Sensor-On-Off",
    "image": "P49TSOO-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "49TSOO",
    "mechs": [
      "PDLP387M3T-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP387AUOD-XW",
    "description": "PDL Pro Rocker Toggle 3-pos UP - OFF - DOWN",
    "name": "Toggle Up-Off-Down",
    "image": "P49TUOD-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "49TUOD",
    "mechs": [
      "PDLP387M3T-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP381PDY-XW",
    "description": "Dolly Rocker DRYER XW",
    "name": "Dryer",
    "image": "PDL381PDY-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": null,
    "mechs": [
      "PDL381M20",
      "PDL381M10",
      "PDLP380M20DP",
      "PDL378M10L"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP380A32HOB-XW",
    "description": "Dolly Rocker HOB 32A  XW\r\n",
    "name": "Hob",
    "image": "PDL381PHOB-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": null,
    "mechs": [
      "PDL380M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDLP381AMICROWV-XW",
    "description": "Dolly Rocker MICROWAVE XW",
    "name": "Microwave",
    "image": "PDL381AMICROWVE-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": null,
    "mechs": [
      "PDL381M20",
      "PDL381M10",
      "PDLP380M20DP",
      "PDL378M10L"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "PDL319MD-TN",
    "description": "PDL Iconic Cat6 RJ45 Module",
    "name": "Cat6 RJ45 Module",
    "image": "PDL319MD-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "VDIB1738XUTN",
    "description": "RJ45 JACK CAT6A UTP 40M TRANSLUCENT.",
    "name": "Cat6a RJ45 Module Translucent",
    "image": "VDIB17386U-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "40E1USBCCAP-CY",
    "description": "Iconic - Mechanism Cap USB Type C",
    "name": "USB Type C Fast Charger",
    "image": "40E1USBCCAP-CY.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40E1USBCCAP",
    "mechs": [
      "PDL342USBC-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCCAP-AG",
    "description": "Iconic - Mechanism Cap USB Type C",
    "name": "USB Type C Fast Charger",
    "image": "40E1USBCCAP-AG.png",
    "category": "USB",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40E1USBCCAP",
    "mechs": [
      "PDL342USBC-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCCAP-AN",
    "description": "Iconic - Mechanism Cap USB Type C",
    "name": "USB Type C Fast Charger",
    "image": "40E1USBCCAP-AN.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40E1USBCCAP",
    "mechs": [
      "PDL342USBC-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCCAP-BK",
    "description": "Iconic - Mechanism Cap USB Type C",
    "name": "USB Type C Fast Charger",
    "image": "40E1USBCCAP-BK.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "XB",
    "baseItemNo": "40E1USBCCAP",
    "mechs": [
      "PDL342USBC-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCCAP-WY",
    "description": "Iconic - Mechanism Cap USB Type C",
    "name": "USB Type C Fast Charger",
    "image": "40E1USBCCAP-WY.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "WY",
    "baseItemNo": "40E1USBCCAP",
    "mechs": [
      "PDL342USBC-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCCAP-VW",
    "description": "Iconic - Mechanism Cap USB Type C",
    "name": "USB Type C Fast Charger",
    "image": "40E1USBCCAP-VW.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40E1USBCCAP",
    "mechs": [
      "PDL342USBC-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  }
]

const MechProducts: readonly MechProduct[] = 
[
  {
    "itemNo": "40CSFM-VW",
    "description": "PDL Iconic Fan Speed Controller, 4-Position, Rotary Switch, Off-1-2-3, Capacitor, 5 Colour Options",
    "displayName": "Fan Controller Off-1-2-3",
    "image": "",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "PDL387A4R (VW)",
    "interfaceDisplayNameOverride": null,
    "category": "Rotary Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL342USB2AC-VW",
    "description": "PDL Iconic Dual USB Charging Mechanism A+C, 15W",
    "displayName": "Dual USB charging mechanism (deep) 3.1A Type A + Type C",
    "image": "40E2USBACM-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "PDL300USB2CAC-VW",
    "interfaceDisplayNameOverride": null,
    "category": "USB",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL381M10",
    "description": "PDL Iconic Switch Mechanism, 1-Way/2-Way, 250V,10AX",
    "displayName": "Switch mech 10 amp",
    "image": "",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40ML",
    "description": "PDL Iconic Switch Mechanism, 1-Way/2-Way, 250V, 10AX, LED",
    "displayName": "Switch mech 10 amp with LED",
    "image": "",
    "supportsLed": true,
    "includesLed": true,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL380M32-VW",
    "description": "PDL Iconic Switch Mechanism, 1-Way, 250V,32A, Vivid White",
    "displayName": "Switch mech 32 amp",
    "image": "40M32-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "PDL380AR32-VW",
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL380M20DP",
    "description": "PDL Iconic Switch Mechanism, 1-Way, Double Pole, 20AX",
    "displayName": "Switch mech 20 amp double pole",
    "image": "",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL378M10",
    "description": "PDL Iconic Switch Mechanism, Intermediate, 250V, 10AX, 1-Way/2-Way, LED",
    "displayName": "Switch mech intermediate 10amp LED",
    "image": "",
    "supportsLed": true,
    "includesLed": true,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": "Intermediate",
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL381M20",
    "description": "PDL Iconic Switch Mechanism, Universal Rocker, 250 V,20 A/16 AX, 1-Way/2-Way",
    "displayName": "Switch mech universal 20A/16AX",
    "image": "",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL354PBDMUN-VW",
    "description": "PDL Iconic Universal Dimmer Mechanism, Pushbutton with ControlLink, 300 W, LED, Vivid White",
    "displayName": "Pushbutton Universal Dimmer 300W 2-wire with ControlLink",
    "image": "41E300PBUD2SM-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "PDL300PBC-VW",
    "interfaceDisplayNameOverride": null,
    "category": "Dimmers",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL356PB10MBTW-VW",
    "description": "PDL Iconic Push Button Wiser Switch Mechanism, 10A, ControlLink, 3-Wire",
    "displayName": "Wiser Push-Button Switch",
    "image": "41E10PBSWM-VW.png",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": "PDL300PBC-VW",
    "interfaceDisplayNameOverride": "Wiser Switch 10A, with ControlLink",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/BLE (Bluetooth)",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL356PB2MBT-VW",
    "description": "Iconic Connected Switch, 2AX, 240V, Vivid White",
    "displayName": "Wiser Switch 2A",
    "image": "",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "PDL300PBC-VW",
    "interfaceDisplayNameOverride": "Wiser Switch 2A",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/BLE (Bluetooth)",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL354PBDMBTW-VW",
    "description": "PDL Iconic Wiser Push-Button LED Dimmer",
    "displayName": "Wiser Dimmer, with ControlLink",
    "image": "",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": "Wiser Dimmer, with ControlLink",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/BLE (Bluetooth)",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL356PB10MBTZ-VW",
    "description": "Iconic Connected Switch, Zigbee Default Mode ControlLink, 300 W, 240 V, Vivid White",
    "displayName": "Wiser Switch 10A, with ControlLink",
    "image": "",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": "PDL300PBC-VW",
    "interfaceDisplayNameOverride": "Wiser Switch 10A, with ControlLink",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/Zigbee",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL356PB2MBTZ-VW",
    "description": "Iconic Connected Switch, Zigbee Default Mode 2AX, 240V, Vivid White",
    "displayName": "Wiser Switch 2A",
    "image": "",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": "PDL300PBC-VW",
    "interfaceDisplayNameOverride": "Wiser Switch 2A",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/Zigbee",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL354PBDMBTZ-VW",
    "description": "Iconic Connected Dimmer, Zigbee Default Mode ControlLink, 300 W, 240 V, Vivid White",
    "displayName": "Wiser Dimmer, with ControlLink",
    "image": "",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": "PDL300PBC-VW",
    "interfaceDisplayNameOverride": "Wiser Dimmer, with ControlLink",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/Zigbee",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL356PBSSL-VW",
    "description": "PDL Iconic Smart PB Remote Mechanism with CTL and LED",
    "displayName": "ControlLink Remote Switch LED",
    "image": "41EPBCLM-VW.png",
    "supportsLed": true,
    "includesLed": true,
    "includedInterfaceItemNo": "PDL300PBC-VW",
    "interfaceDisplayNameOverride": "ControlLink Remote Switch LED",
    "category": "Bluetooth",
    "subcategory": "Remote Push Button Switches",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL356PBSS-VW",
    "description": "PDL Iconic ControlLink Remote Switch Mechanism, Momentary Pushbutton, Vivid White",
    "displayName": "ControlLink Remote Switch",
    "image": "41EPBM-VW.png",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": "PDL300PBC-VW",
    "interfaceDisplayNameOverride": "ControlLink Remote Switch",
    "category": "Bluetooth",
    "subcategory": "Remote Push Button Switches",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL387M3T-VW",
    "description": "PDL Iconic Switch Mechanism, 3-Position Toggle, 250V, 10A, Vivid White",
    "displayName": "3 position toggle switch",
    "image": "49M-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "PDL387A3T-VW",
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL354RDMLED2-VW",
    "description": "PDL Iconic Dimmer Mechanism, LED, Rotary, 220-240V, 150W, vivid white, 40 series",
    "displayName": "Rotary LED Dimmer 150W",
    "image": "",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "PDL300KBC-VW",
    "interfaceDisplayNameOverride": null,
    "category": "Dimmers",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL354RDMUN-VW",
    "description": "PDL Iconic Universal Dimmer Mechanism, Rotary, 350 W,Vivid White",
    "displayName": "Rotary Universal Dimmer 350W 2-wire",
    "image": "42E350RUD2M-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "PDL300KBC-VW",
    "interfaceDisplayNameOverride": null,
    "category": "Dimmers",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "5041NMML",
    "description": "C-Bus 40 SERIES MASTER MODULE",
    "displayName": "C-Bus 40 Series Master Module",
    "image": "",
    "supportsLed": true,
    "includesLed": true,
    "includedInterfaceItemNo": "PDL300KBC-VW",
    "interfaceDisplayNameOverride": "C-Bus 40 Series Master Module",
    "category": "Bluetooth",
    "subcategory": "C-Bus Switches",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "5041NMS",
    "description": "C-Bus 40 SERIES SLAVE MODULE",
    "displayName": "C-Bus 40 Series Slave Module",
    "image": "",
    "supportsLed": true,
    "includesLed": true,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": "C-Bus 40 Series Slave Module",
    "category": "Bluetooth",
    "subcategory": "C-Bus Switches",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDLP40CSFM-XW",
    "description": "PDL Pro Fan Speed Controller, 4-Position, Rotary Switch, Off-1-2-3, Capacitor 75VA",
    "displayName": "Fan Controller Off-1-2-3",
    "image": "P40CSFM-XW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "PDLP40CSFM-XW",
    "interfaceDisplayNameOverride": null,
    "category": "Rotary Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "PDLP380M32O-XW",
    "description": "PDL Pro Switch Mechanism, Cooker, 1-Way, 250V, 32A",
    "displayName": "Cooker mech",
    "image": "P40M32COOK-XW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "P40R32COOK-XW",
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "PDLP380M20DP",
    "description": "PDL Pro Switch Mechanism, 1-Way, Double Pole, 250V, 20AX",
    "displayName": "Double pole mech 20 AX",
    "image": "",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "PDLP387M4R2-XW",
    "description": "PDL Pro Switch Mechanism, 4-Position, 250V, 10A, White",
    "displayName": "4 Position Rotary Knob OFF-1-OFF-1",
    "image": "40RSM2KB-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "PDLP387M4R2-XW",
    "interfaceDisplayNameOverride": null,
    "category": "Rotary Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "PDLP387M4R3-XW",
    "description": "PDL Pro Switch Mechanism, 4-Position, 250V, 10A, White",
    "displayName": "4 Position Rotary Knob OFF-1-2-3",
    "image": "P40RSM3-XW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "PDLP387M4R3-XW",
    "interfaceDisplayNameOverride": null,
    "category": "Rotary Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "PDLP387M3T-XW",
    "description": "PDL Pro Switch Mechanism, 3-Position, 10A, 250V",
    "displayName": "3 position mech ",
    "image": "P49M-XW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "PDLP387M3TM-XW",
    "description": "PDL Pro Switch Mechanism, 3-Position, Bell Press Return, 10A, 250V",
    "displayName": "3 position mech bell press",
    "image": "P49MBPR-XW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "PDLP387M3T-XW",
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL378M10L",
    "description": "PDL Iconic Switch Mechanism, Intermediate, 250V, 10AX, 1-Way/2-Way",
    "displayName": "Intermediate mech ",
    "image": "40MI.png",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "PDL342USBC-VW",
    "description": "Iconic USB Fast charger, Type C, 25W, 240V",
    "displayName": "USB Fast Charger",
    "image": "40E1USBCM-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "USB",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  }
]

const ProductRules: readonly ProductRule[] = 
[
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 2,
    "orientation": "Both",
    "products": [
      "PDL342USB2AC-VW",
      "PDL342USBC-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 3,
    "orientation": "Both",
    "products": [
      "PDL356PB10MBTW-VW",
      "PDL354PBDMBTW-VW"
    ]
  },
  {
    "ruleType": "SwitchOnly",
    "products": [
      "PDL352MPIR-TN"
    ]
  },
  {
    "ruleType": "RequiresOtherMech",
    "otherMechs": [
      "PDL381M10"
    ],
    "products": [
      "PDL354RDMLED2-VW",
      "PDL354RDMUN-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 3,
    "orientation": "Both",
    "products": [
      "PDL352MPIR-TN"
    ]
  },
  {
    "ruleType": "ExclusiveCategory",
    "category": "Network",
    "subcategory": null
  },
  {
    "ruleType": "ExclusiveCategory",
    "category": "Bluetooth",
    "subcategory": "C-Bus Switches"
  },
  {
    "ruleType": "IncompatibleGrids",
    "incompatibleGrids": [
      "PDL362G"
    ],
    "products": [
      "PDL356PB10MBTW-VW",
      "PDL354PBDMBTW-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 2,
    "orientation": "Horizontal",
    "products": [
      "PDL380M32-VW"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "PDL356PB2MBTZ-VW"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "PDL356PB10MBTZ-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 3,
    "orientation": "Both",
    "products": [
      "PDL356PB10MBTZ-VW"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "PDL354PBDMBTZ-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 3,
    "orientation": "Both",
    "products": [
      "PDL354PBDMBTZ-VW"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "PDL395CSGZ"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "PDL5010WDZ"
    ]
  },
  {
    "ruleType": "RequiresMomentarySwitches",
    "overrideMech": "PDL356PBSS-VW",
    "products": [
      "PDL5010WDZ"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "PDL5011WSZ"
    ]
  },
  {
    "ruleType": "RequiresMomentarySwitches",
    "overrideMech": "PDL356PBSS-VW",
    "products": [
      "PDL5011WSZ"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "PDL5015WBZ"
    ]
  },
  {
    "ruleType": "RequiresMomentarySwitches",
    "overrideMech": "PDL356PBSS-VW",
    "products": [
      "PDL5015WBZ"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "PDL595011"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "PDL593011"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "PDL592011"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "PDL591011"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "PDL501902_001"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "PDL501401"
    ]
  }
]

const ConstantProducts: ConstantProductsShape = {
  WiserHub: "PDL501902",
  WiserSwitchDefaultMech: "PDL356PB2MBTZ-VW",
}

const PdlProductData = { GridProducts, SkinProducts, InterfaceProducts, MechProducts, ProductRules, ConstantProducts }
export default PdlProductData